import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { TagsInput } from "react-tag-input-component";
import "./Editvideo.css";
import { toast } from "react-toastify";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import usePpvGlobalImageConfig from "../../../components/CommonApis/ppv_global_change";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { getItemToken } from "../../../Utils/localStorageUtils";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminDownloadFile from "../../../components/CommonComponents/AdminDownloadFile";
import AdminCustomRadio from "../../../components/CommonComponents/AdminCustomRadio";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import { IconMyDelete, IconMyPlus } from "../../../Assets/MyIcons";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoClose } from "react-icons/io5";
import { useMyContext } from "../../../components/Provider/CommonProvider"
import AdminGalleryModal from "../../../components/CommonComponents/AdminGalleryModal";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import AdminMiniPlayer from '../../../components/CommonComponents/AdminMiniPlayer';
import AdminYoutubePlayer from "../../../components/CommonComponents/AdminYoutubePlayer";
import AdminProcessButton from "../../../components/CommonComponents/AdminProcessButton";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { PiSubtitlesLight } from "react-icons/pi";
import { isHttpOrHttps, slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import { connect } from "react-redux";
import AdminCheckBox from "../../../components/CommonComponents/AdminCheckBox";
import { IoIosInformationCircleOutline } from "react-icons/io";
import AdminCustomURLCopy from "../../../components/CommonComponents/AdminCustomURLCopy";
import { navigateChecker } from "../../../components/navigateChecker";
// Custom Fields imports removed - feature disabled
import AdminAIModal from "../../../components/CommonComponents/AdminAImodal";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import PushNotificationSettings from "../../../components/CommonComponents/PushNotificationSettings";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import AddManagevideocategories from "./AddManagevideocategories";
import AddManageAge from "../../Site/Settings/AddManageAge";
import LanguageAddUpdate from "../../Language/Manage_Language/LanguageAddUpdate";
import ArtistAddUpdate from "../../Audio/Artist_Management/ArtistAddUpdate";
import { MdAddCircle } from "react-icons/md";
import { FaExternalLinkAlt } from "react-icons/fa";
import StorageLimitModal from "../../../components/CommonComponents/StorageLimitModal";
import ContentClassification from "../../Site/Settings/Site_Setting/ContentClassification";

const VideoAddUpdate = ({ storageSetting, storageLoading, siteTheme, languageCodeData, onlyPermission }) => {
    const { handleFileChangeProvider, fetchRequest, buildDynamicSubText, validateOrientationBySlug, validateImageRatio, globalImageUplaodAPI, imageValidationAPI, fileResponse, clearFileResponse } = useMyContext()
    const { compressResolutionFormat } = useCompressImageConfig();
    const { allCurrencylistfromappi, globalPpvStatusActive } = usePpvGlobalImageConfig();
    const [showStorageModal, setShowStorageModal] = useState(false);
    useEffect(() => {
        if (fileResponse === 413) {
            setShowStorageModal(true);
        }
    }, [fileResponse]);

    const handleStorageModalClose = () => {
        setShowStorageModal(false);
        clearFileResponse();
    };
    const baseURL = process.env.REACT_APP_Baseurl
    const headers = getItemToken('access_token')

    const editVideoRegex = /^\/edit-new-video\/\d+$/
    const { id } = useParams()
    const location = useLocation()

    const titleApi = `${baseURL}/admin/library/search-title`
    const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`
    const [modalTarget, setModalTarget] = useState(null);
    const [imagerequiredValidation, setImagerequiredValidation] = useState();
    const [defaultPrompt, setDefaultPrompt] = useState("");

    const [apiConfig, setApiConfig] = useState({
        api: '',
        body: { source_type: 1, upload_source_type: 1, }
    })


    const combinedRef = useRef({
        title: null,
        slug: null,
        description: null,
        details: null,
        rating: null,
        age_restrict: null,
        duration: null,
        free_duration_time: null,
        skip_start_time: null,
        skip_end_time: null,
        recap_start_time: null,
        mid_advertisement_sequence_time: null,
        recap_end_time: null,
        category_checkbox: null,
        notification_image: null
    });

    const cdnApis = {
        bunny: {
            libraryIndex: `${baseURL}/admin/bunny-cdn-video-library`,
            uploadApi: `${baseURL}/admin/bunny-cdn-video-upload-library`,
            libraryFind: `${baseURL}/admin/bunny-cdn-stream-video-library`,
            moveApi: `${baseURL}/admin/bunny-cdn-stream-video-update-library`
        },
        videocipher: {
            libraryIndex: `${baseURL}/admin/videoCipher-videoIndex`,
            moveApi: `${baseURL}/admin/videoCipher-UpdateVideoId`,
            uploadApi: `${baseURL}/admin/videoCipher-uploadVideo`
        }
    }


    const navigate = useNavigate()
    const labelSource = 'add-edit-video'
    const [customFieldValues, setCustomFieldValues] = useState({});
    // Custom Fields disabled - removed state

    const editApi = `${baseURL}/admin/videos-edit`
    const updateApi = `${baseURL}/admin/video-update`
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
    const paperApi = `${baseURL}/admin/Epaper-video`
    const trailerApiLibrary = `${baseURL}/admin/library/upload?upload_type=trailer&clone_to=video&action_type=updated`
    const seoApi = `${baseURL}/admin/videos-SEO`
    const imageApi = globalImageUplaodAPI();
    const imageValidationApi = imageValidationAPI();
    const reelsImageApi = `${baseURL}/admin/video-reels-thumbnail`
    const globalDeleteApi = `${baseURL}/admin/global-image-delete`
    const createApi = `${baseURL}/admin/videos-create`
    // const uploadFileApi = `${baseURL}/admin/video-upload-file`
    const uploadFileApi = `${baseURL}/admin/library/upload?upload_type=video&clone_to=video`

    const uploadURLApi = `${baseURL}/admin/videos-url`
    const updateURLApi = `${baseURL}/admin/video/url-update/${id}`

    const storeApi = `${baseURL}/admin/video-store`
    const updatePPV = `${baseURL}/admin/Video/PayPerViewPrice/StoreUpdate`
    const moveApi = `${baseURL}/admin/video-move`
    const assingAPI = `${baseURL}/admin/video/assignto`

    const [formData, setFormData] = useState({
        state: "formData",
        title: "",
        slug: "",
        year: new Date().getFullYear(),
        url_type: '',
        selected_categories: "",
        tv: "",
        image: "",
        player: "",
        age_restrict: 0,
        rating: 0,
        publish_type: "",
        free_duration_status: 0,
        free_duration_time: "",
        enable_Tips: 0,
        enable_restream: 0,
        global_ppv: 0,
        global_ios_ppv: 0,
        // New Ideabiz purchase plan mapping
        ideabiz_purchase_plans_id: null,
        google_product_id_ppvs_id: null,
        trailer_type: 'mp4_video_upload',
        error: "",
        pre_ads: "",
        post_ads: "",
        mid_ads_category: "",
        upload_single: null,
        active: 0,
        mid_advertisement_sequence_time: "",
        ssai_enable: 0,
        ssai_mid_ad_sequence_time: "",
        brightcove_video_id: "",
        brightcove_trailer_videos_id: "",
        brightcove_account_id: "",
        push_notification_enabled: 0,
        push_notification_title: "",
        push_notification_description: "",
        push_notification_publish_type: "publish_now",
        push_notification_publish_time: "",
        push_notification_source_type: 1,
        push_notification_source_type_name: "Videos",
        push_notification_slug: "",
        content_classification: "",
        is_ads: 0,
        banner: 0,
        slider_image: "",
    })
    const [videoCipherIds, setVideoCipherIds] = useState([])
    const [cloudLibrary, setCloudLibrary] = useState([1, 2, 3])
    const [activeLibrary, setActiveLibrary] = useState()
    const [libraryVideos, setLibraryVideos] = useState()
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [total, setTotal] = useState('')
    const [editData, setEditData] = useState()
    const [defaultEditOption, setDefaultEditOption] = useState()
    const [editVideoStatus, setEditVideoStatus] = useState(false)
    const [videoPlaylistOptions, setVideoPlaylistOptions] = useState([]);
    const [selectedVideoPlaylists, setSelectedVideoPlaylists] = useState([]);
    const [videoPlaylistLoading, setVideoPlaylistLoading] = useState(false);
    const [videoPlaylistSyncing, setVideoPlaylistSyncing] = useState(false);
    const [getGeofencingAvailableCountries, setGetGeoFencingAvailableCountries] = useState(null);
    const [getGeofencing, setGetGeoFencing] = useState(null);
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
        artistsOption: [],
        categoryOption: [],
        languageOption: [],
        regionOption: [],
        blockCountryOption: [],
        availableCountryOption: [],
        relatedVideos: [],
        relatedPlaylists: [],
        writerOption: [],
        musicianOption: [],
        ageOption: [],
        albumOption: [],
        accessOption: [],
        iosOption: [],
        lyricsOption: [],
        globalOption: [],
        ideabizPPVPurchase: [],
        googleProductIdPPV: [],
        classificationOption: [],
        trailerOption: [
            // { name: "Video Upload", value: "mp4_video_upload" },
            // { name: "M3u8 URL", value: "m3u8_url" },
            // { name: "Mp4 URL", value: "mp4_url" },
            // { name: "Embed URL", value: "embed_code" },
        ]
    })

    const [files, setFiles] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedClassifications, setSelectedClassifications] = useState([]);

    const [subtitleFile, setSubtitleFile] = useState()
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [modelClose, setModelClose] = useState(false);
    const [modelCloseVdoCiPher, setModelCloseVdoCipher] = useState(false);
    const [selectedFieldConfigs, setSelectedFieldConfigs] = useState({}); // { apiFieldName: orientationSlug }
    const [uiToApiFieldMap, setUiToApiFieldMap] = useState({}); // { uiName: apiFieldName }
    const [enableCroppingOverrideOnUpload, setEnableCroppingOverrideOnUpload] = useState(null); // '1' | '0' | null

    const [pricemodel, setPriceModel] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [categoryModal, setCategoryModal] = useState(false);
    const [ageModal, setAgeModal] = useState(false);
    const [classificationModal, setClassificationModal] = useState(false);
    const [languageModal, setLanguageModal] = useState(false);
    const [artistModal, setArtistModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});
    const [loading, setLoading] = useState(false);
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [formDataError, setFormDataError] = useState({})
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [playerImageFile, setPlayerImageFile] = useState(null);
    const [titleImageFile, setTitleImageFile] = useState(null);
    const [tvImageFile, setTvImageFile] = useState(null);
    const [sliderImageFile, setSliderImageFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [reelsImageFile, setReelsImageFile] = useState(null);
    const [notificationImageFile, setNotificationImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [step, setStep] = useState(1)
    const [currentType, setCurrentType] = useState("")
    const [preadsarray, setPreadsarray] = useState([])
    const [postadsarray, setPostadsarray] = useState([])
    const [midadsarray, setMidadsarray] = useState([])
    const [trailerVideoUpload, setTrailerVideoUpload] = useState(null);

    // Transcoding status banner state
    const [transcodingEnabled, setTranscodingEnabled] = useState(true);
    const [hideTranscodingBanner, setHideTranscodingBanner] = useState(false);

    const [currentId, setCurrentId] = useState({
        mp4Response: {},
        m3u8URLResponse: {},
        mp4URLResponse: {},
        embedURLResponse: {},
        moveId: ""
    })
    const [galleryModal, setGalleryModal] = useState(false)
    const [galleryModalSourceFillter, setGalleryModalSourceFillter] = useState(1)

    const [convertPrice, setConvertPrice] = useState({
        source_type: 1,
        source_id: "",
        PPVType: "",
        PriceType: "",
        ActualPrice: "",
        IOSPrice: "",
        convertedPriceRates: []
    })

    // Same Country PPV Modal State
    const [samePriceModel, setSamePriceModel] = useState(false)
    const [sameConvertPrice, setSameConvertPrice] = useState({
        source_type: 1,
        source_id: "",
        PPVType: "",
        PriceType: "",
        ActualPrice: "",
        IOSPrice: "",
        convertedPriceRates: []
    })



    function formatFileSize(bytes) {
        const gb = bytes / 1_000_000_000;
        const mb = bytes / 1_000_000;
        if (gb >= 1) {
            return `${gb.toFixed(2)} GB`;
        } else if (mb >= 1) {
            return `${mb.toFixed(2)} MB`;
        } else {
            return `${(bytes / 1000).toFixed(2)} KB`;
        }
    }


    const currentYear = new Date().getFullYear();
    // formData.year = currentYear;
    const years = Array.from({ length: currentYear - 1895 + 1 }, (_, index) => ({ name: 1895 + index, value: 1895 + index }));


    const handlePriceModal = () => {
        setPriceModel((prev) => !prev)
    }
    const handlePriceModalClose = async () => {
        setFormData((prev) => ({
            ...prev,
            ppv_price: editData?.ppv_price,
            ios_ppv_price: editData?.ios_ppv_price,
            global_ppv: editData?.global_ppv
        }))
        await handlePriceModal()
        // await handleCovertPrice(editData?.ppv_price)
    }

    // Helper to safely read DefaultCurrency (object in edit, array[0] in create)
    const getDefaultCurrencySetting = () => {
        const dc = defaultOption?.defaultCurrency;
        if (Array.isArray(dc)) return dc?.[0] || {};
        return dc || {};
    }

    // Decide which Customize PPV modal to open
    const handleCustomizePPVClick = () => {
        const cfg = getDefaultCurrencySetting();
        const isMulti = cfg?.enable_multi_currency == 1;
        const isSecondary = cfg?.enable_secondary_currency == 1;
        const isSameToggle = cfg?.same_country_toggle == 1;
        const sameCountry = (cfg?.same_currency_country || '').toLowerCase();
        if (isMulti) {
            handlePriceModal();
        } else if (isSecondary) {
            handlePriceModal();
        } else if (isSameToggle && cfg?.same_currency_country) {
            setSamePriceModel(true);
            if (formData?.ppv_price) {
                handleSameCountryConvert(formData?.ppv_price);
            }
        } else {
            toast.info('Customize PPV is available only in Multi Currency, Secondary Currency, or Same Country mode.');
        }
    }

    const handleSameCountryPriceModalClose = () => {
        setSamePriceModel(false)
    }

    // Handle PPV Purchase Plan selection (existing field)
    const handlePpvPlanSelect = (planId) => {
        if (planId && planId !== '') {
            const ppvPurchasePlansId = JSON.stringify({
                payment_id: parseInt(planId)
            });

            setFormData(prev => ({
                ...prev,
                ppv_purchase_plans_id: ppvPurchasePlansId
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                ppv_purchase_plans_id: null
            }));
        }
    };

    // Handle Ideabiz Purchase Plan selection (new field)
    // Store only the raw plan ID (number) – backend will receive just the ID, not a JSON string
    const handleIdeabizPlanSelect = (planId) => {
        if (planId && planId !== '') {
            setFormData(prev => ({
                ...prev,
                ideabiz_purchase_plans_id: parseInt(planId)
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                ideabiz_purchase_plans_id: null
            }));
        }
    };

    const handleGoogleProductPlanSelect = (planId) => {
        if (planId && planId !== '') {
            setFormData(prev => ({
                ...prev,
                google_product_id_ppvs_id: parseInt(planId)
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                google_product_id_ppvs_id: null
            }));
        }
    };

    const handleCheckboxChange = (id) => {
        if (galleryModalSourceFillter == 1 && !editVideoStatus) {
            setSelectedIds((prevSelectedIds) => {
                if (prevSelectedIds.includes(id)) {
                    return prevSelectedIds.filter((itemId) => itemId !== id);
                } else {
                    return [...prevSelectedIds, id];
                }
            });
        }
        if (galleryModalSourceFillter == 16 || editVideoStatus) {
            setSelectedIds([id]);
        }
    };

    const formatSpeed = (speedInBytes) => {
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let unitIndex = 0;
        let speed = speedInBytes;

        while (speed >= 1024 && unitIndex < units.length - 1) {
            speed /= 1024;
            unitIndex++;
        }

        return `${speed.toFixed(2)} ${units[unitIndex]}`;
    };

    const handleNextMethod = (movingId) => {
        navigate(`/edit-video/${movingId}`)
        // setStep(2)

        // setCurrentId(prev => ({
        //   ...prev,
        //   moveId: movingId
        // }))
        // console.log(movingId)
    }

    const handleAddMore = (name) => {
        if (name == "m3u8_url") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.m3u8URLResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                m3u8_url: ""
            }))
        }
        if (name === "mp4_url") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.mp4URLResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                mp4_url: ""
            }))
        }
        if (name === "embed_code") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.embedURLResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                embed_code: ""
            }))
        }
        if (name === "brightcove") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.brightcoveResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                brightcove_video_id: "",
                brightcove_account_id: ""
            }))
        }
    }
    const handleUrlUpload = async (name) => {
        const formDataObject = {};
        let formIsValid = true
        if (name == "mp4_url") {
            if (!formData?.mp4_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    mp4_url: "Mp4 url cannot be empty.",
                }));
                combinedRef.current['mp4_url']?.focus()
                formIsValid = false;
                return
            } else if (!formData?.mp4_url.toLowerCase().endsWith('.mp4')) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    mp4_url: "Please provide a valid MP4 URL ending with .mp4",
                }));
                combinedRef.current['mp4_url']?.focus()
                formIsValid = false;
                return
            } else {
                formDataObject["mp4_url"] = formData?.mp4_url?.trim();
                formDataObject["video_type"] = name;
            }
        }
        if (name == "m3u8_url") {
            if (!formData?.m3u8_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    m3u8_url: "M3u8 url cannot be empty.",
                }));
                combinedRef.current['m3u8_url']?.focus()
                formIsValid = false;
                return
            } else if (!formData?.m3u8_url.toLowerCase().endsWith('.m3u8')) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    m3u8_url: "Please provide a valid M3U8 URL ending with .m3u8",
                }));
                combinedRef.current['m3u8_url']?.focus()
                formIsValid = false;
                return
            } else {
                formDataObject["m3u8_url"] = formData?.m3u8_url?.trim();
                formDataObject["video_type"] = name;
            }
        }
        if (name == "embed_code") {
            if (!formData?.embed_code) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    embed_code: "Embed code cannot be empty.",
                }));
                combinedRef.current['embed_code']?.focus()
                formIsValid = false;
                return
            } else {
                const embedCode = formData?.embed_code?.trim();
                const youtubeEmbedRegex = /^https?:\/\/(?:www\.)?youtube\.com\/embed\/[a-zA-Z0-9_-]+(\?[a-zA-Z0-9_=&-]+)?$/;
                if (!youtubeEmbedRegex.test(embedCode)) {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        embed_code: "Invalid YouTube embed URL. Please provide a valid URL in format: https://www.youtube.com/embed/VIDEO_ID",
                    }));
                    combinedRef.current['embed_code']?.focus()
                    formIsValid = false;
                    return
                }
                else {
                    formDataObject["embed_code"] = embedCode;
                    formDataObject["video_type"] = "embed_code";
                }
            }
        }
        if (name == "brightcove") {
            if (!formData?.brightcove_video_id) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    brightcove_video_id: "Brightcove Video ID is required.",
                }));
                combinedRef.current['brightcove_video_id']?.focus()
                formIsValid = false;
                return
            } else {
                formDataObject["brightcove_video_id"] = formData?.brightcove_video_id?.trim();
                // formDataObject["brightcove_account_id"] = formData?.brightcove_account_id?.trim(); // Removed as we use default from settings
                formDataObject["video_type"] = "brightcove";
            }
        }
        if (formIsValid) {
            setLoading(true)
            try {
                const response = await axios.post(`${editVideoStatus ? updateURLApi : uploadURLApi}`, formDataObject, { headers: headers })
                const result = response?.data
                if (result?.status) {
                    toast.success(result?.message)
                    setCurrentId(prev => {
                        const updatedState = { ...prev };
                        if (name === "m3u8_url") {
                            updatedState.m3u8URLResponse = { ...result, id: result?.id };
                        }
                        if (name === "mp4_url") {
                            updatedState.mp4URLResponse = { ...result, id: result?.id };
                        }
                        if (name === "embed_code") {
                            updatedState.embedURLResponse = { ...result, id: result?.id };
                        }
                        if (name === "brightcove") {
                            updatedState.brightcoveResponse = { ...result, id: result?.id };
                        }
                        return updatedState;
                    });

                }
            }
            catch (error) {
                const errorMessage = error?.response?.data?.message;
                toast.error(errorMessage)
            }
            finally {
                setLoading(false)
            }
        }

    }

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        if (value == 'reels') {
            setReelsImageFile(null)
        }
        if (value == 'title_image') {
            setTitleImageFile(null)
        }
        if (value == 'tv') {
            setTvImageFile(null)
        }
        if (value == 'player') {
            setPlayerImageFile(null)
        }
        if (value == 'notification_image') {
            setNotificationImageFile(null)
        }
        if (value == 'slider_image') {
            setSliderImageFile(null)
        }
        setSelectedFieldConfigs((prev) => {
            const copy = { ...prev };
            const apiField = uiToApiFieldMap[value];
            if (apiField) {
                delete copy[apiField];
            }
            return copy;
        });
        setUiToApiFieldMap((prev) => {
            const cp = { ...prev };
            delete cp[value];
            return cp;
        });
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))
        setSubtitleFile((prev) => ({
            ...prev,
            [value]: ""
        }))

    }

    // Fetch transcoding status (from setup-progress API)
    useEffect(() => {
        let cancelled = false;
        const fetchTranscodingStatus = async () => {
            try {
                const resp = await axios.get(`${baseURL}/admin/setup-progress`, { headers });
                const enabled = !!resp?.data?.data?.progress?.transcoding;
                if (!cancelled) setTranscodingEnabled(enabled);
            } catch (e) {
                // fail silently; keep default true to avoid blocking UI
            }
        };
        fetchTranscodingStatus();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseURL]);

    const handlePdfSubtitleFileChange = async (event) => {
        const { files, name, accept } = event.target;

        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (!files || files.length === 0) {
            return;
        }

        const newFile = files[0];

        if (accept === 'application/pdf') {
            const allowedTypes = ['application/pdf'];
            const isPdf = allowedTypes.includes(newFile.type) ||
                newFile.name.toLowerCase().endsWith('.pdf');

            if (!isPdf) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only PDF files are allowed.",
                }));
                setPdfFile(null);
                return;
            }
            setPdfFile(newFile);
        }
        // VTT and SRT Validation
        else if (accept === 'text/vtt,text/srt,.vtt,.srt') {
            const fileName = newFile.name.toLowerCase();
            const isVttFile = fileName.endsWith('.vtt');
            const isSrtFile = fileName.endsWith('.srt');

            if (!isVttFile && !isSrtFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only VTT & SRT files are allowed.",
                }));
                setSubtitleFile((prev) => ({
                    ...prev,
                    [name]: '',
                }));
                return;
            }

            // Validate file content
            const reader = new FileReader();
            reader.onload = (e) => {
                const content = e.target.result;
                let isValid = true;
                let errorMessage = "";

                if (isVttFile) {
                    // VTT files should start with "WEBVTT"
                    if (!content.trim().startsWith('WEBVTT')) {
                        isValid = false;
                        errorMessage = "VTT file must start with 'WEBVTT' header.";
                    }
                } else if (isSrtFile) {
                    // SRT files should contain timestamp patterns like "00:00:01,000 --> 00:00:05,000"
                    const srtTimestampRegex = /\d{2}:\d{2}:\d{2},\d{3}\s*-->\s*\d{2}:\d{2}:\d{2},\d{3}/;
                    if (!srtTimestampRegex.test(content)) {
                        isValid = false;
                        errorMessage = "SRT file must contain valid timestamp format (HH:MM:SS,mmm --> HH:MM:SS,mmm).";
                    }
                }

                if (isValid) {
                    setSubtitleFile((prev) => ({
                        ...prev,
                        [name]: newFile,
                    }));
                } else {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: errorMessage,
                    }));
                    setSubtitleFile((prev) => ({
                        ...prev,
                        [name]: '',
                    }));
                }
            };
            reader.readAsText(newFile);
        }
    };

    const handleFileChange = async (event) => {
        const { files, name, value, accept, dataset } = event.target
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
        const checkSize = compressResolutionFormat?.videos === 1
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);
            if (dataset?.apifield && dataset?.orientation) {
                setSelectedFieldConfigs((prev) => ({ ...prev, [dataset.apifield]: dataset.orientation }));
                setUiToApiFieldMap((prev) => ({ ...prev, [name]: dataset.apifield }));
            }
            if (typeof dataset?.enableCropping !== 'undefined') {
                setEnableCroppingOverrideOnUpload(dataset.enableCropping);
            }

            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, WEBP and PNG files are allowed.",
                }));
                if (name === 'image') setCoverImageFile(null);
                if (name === 'notification_image') setNotificationImageFile(null);
                if (name === 'player') setPlayerImageFile(null);
                if (name === 'tv') setTvImageFile(null);
                if (name === 'title_image') setTitleImageFile(null);
                if (name === 'slider_image') setSliderImageFile(null);
                combinedRef.current[name].focus()
                return;
            }
            if (dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                if (name === "slider_image") {
                    const isValid = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
                    if (!isValid) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be 3840x1440px or in 8:3 Ratio",
                        }));
                        setSliderImageFile(null);
                        combinedRef.current[name]?.focus?.();
                        return;
                    }
                }
                const result = await validateOrientationBySlug(newFile, dataset.orientation);
                if (!result.ok) {
                    let msg = 'Selected image does not match the required orientation.';
                    if (result?.expected) {
                        const ratio = result?.ratio || `${result.expected.width}:${result.expected.height}`;
                        msg = `Image must be in ${ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                    } else if (result?.actual) {
                        const s = String(result.slug);
                        if (s === 'landscape') msg = `Please upload a landscape image (width > height). Uploaded: ${result.actual.width}x${result.actual.height}.`;
                        else if (s === 'portrait') msg = `Please upload a portrait image (height > width). Uploaded: ${result.actual.width}x${result.actual.height}.`;
                        else if (s === 'square') msg = `Please upload a square image (width = height). Uploaded: ${result.actual.width}x${result.actual.height}.`;
                    }
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: msg,
                    }));
                    if (name === 'image') setCoverImageFile(null);
                    if (name === 'player') setPlayerImageFile(null);
                    if (name === 'tv') setTvImageFile(null);
                    if (name === 'title_image') setTitleImageFile(null);
                    if (name === 'slider_image') setSliderImageFile(null);
                    combinedRef.current[name]?.focus?.();
                    return;
                }
            }

            if (name == 'image') {
                setCoverImageFile(newFile);
                if (checkSize && !dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 2:3 Ratio or 1080x1620px",
                        }));
                    }
                }
            }
            if (name == 'player') {
                setPlayerImageFile(newFile);
                if (checkSize && !dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 16:9 Ratio or 1280x720px",
                        }));
                    }
                }
            }
            if (name == 'tv') {
                setTvImageFile(newFile);
                if (checkSize && !dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 16:9 Ratio or 1280x720px",
                        }));
                    }
                }
            }
            if (name == 'title_image') {
                setTitleImageFile(newFile);
                if (checkSize && !dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 16:9 Ratio or 1280x720px",
                        }));
                    }
                }
            }
            if (name == 'notification_image') {
                setNotificationImageFile(newFile);
                if (checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 2 / 1, 1024, 512);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 2:1 Ratio or 1024x512px",
                        }));
                    }
                }
            }
            if (name == 'reels') {
                setReelsImageFile(newFile);
            }
            if (name == 'trailer') {
                setTrailerVideoUpload(newFile);
            }
            if (name == 'slider_image') {
                setSliderImageFile(newFile);
                if (checkSize && !dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 8:3 Ratio or 3840x1440px",
                        }));
                    }
                }
            }
        }
    };

    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };

    const assignDefault = (value, defaultValue = 0) => value ? value : defaultValue;

    const fetchData = async () => {
        setShowOverlay(true)
        try {
            const response = await axios.get(`${editApi}/${id}`, { headers: headers });
            const result = response?.data;
            setGetGeoFencing(result?.getGeofencing);
            setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
            setPreadsarray(result?.pre_advertisement)
            setPostadsarray(result?.post_advertisement)
            setMidadsarray(result?.ads_category)
            const previousFormData = result?.video;
            const updatedFormData = {
                ...previousFormData,
                brightcove_video_id: previousFormData?.remote_storage_id || "",
                brightcove_trailer_videos_id: previousFormData?.brightcove_trailer_videos_id || "",
                brightcove_account_id: previousFormData?.brightcove_account_id || "",
                selected_artists: multiSelectLabel(previousFormData?.selected_artists, 'id', 'name'),
                selected_categories: previousFormData?.selected_categories,
                selected_Languages: multiSelectLabel(previousFormData?.selected_Languages, 'id', 'name'),
                selected_Regions: multiSelectLabel(previousFormData?.selected_Regions, 'id', 'name'),
                selected_blocked_country: multiSelectLabel(previousFormData?.selected_blocked_country, 'id', 'name'),
                selected_available_country: multiSelectLabel(previousFormData?.selected_available_country, 'id', 'country_name'),
                selected_playlist_videos: multiSelectLabel(previousFormData?.selected_playlist_videos, 'id', 'name'),
                selected_related_videos: multiSelectLabel(previousFormData?.selected_related_videos, 'id', 'name'),
                publisher_musician: multiSelectLabel(previousFormData?.publisher_musician, 'id', 'name'),
                publisher_songwriter: multiSelectLabel(previousFormData?.publisher_songwriter, 'artist_id', 'name'),
                search_tags: previousFormData?.search_tags?.split(",")?.map((tag) => tag?.trim()),
                ppv_status: assignDefault(previousFormData.ppv_status),
                ppv_purchase_plans_id: previousFormData?.ppv_purchase_plans_id || null,
                // map existing ideabiz purchase plan if present from API
                ideabiz_purchase_plans_id: previousFormData?.ideabiz_purchase_plans_id || null,
                album_id: assignDefault(previousFormData.album_id),
                rating: assignDefault(previousFormData.rating),
                active: assignDefault(previousFormData.active),
                draft: assignDefault(previousFormData.draft),
                featured: assignDefault(previousFormData.featured),
                banner: assignDefault(previousFormData.banner),
                views: assignDefault(previousFormData.views),
                year: previousFormData.year,
                publish_type: previousFormData.publish_type ? previousFormData.publish_type : 'publish_now',
                age_restrict: assignDefault(previousFormData.age_restrict),
                push_notification_enabled: assignDefault(previousFormData?.push_notification_enabled),
                push_notification_title: previousFormData?.push_notification_title || "",
                push_notification_description: previousFormData?.push_notification_description || "",
                push_notification_image: previousFormData?.push_notification_image || "",
                push_notification_publish_type: previousFormData?.push_notification_publish_type || "publish_now",
                push_notification_publish_time: previousFormData?.push_notification_publish_time || "",
                content_classification: previousFormData?.content_classification || "",
            };
            setCurrentType(previousFormData?.type == "transcoding_video" ? "mp4_video_upload" : previousFormData?.type)
            setFormData((prev) => ({ ...prev, ...updatedFormData }))
            setEditData(updatedFormData)


            // Default DropDown List

            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result.artists, 'id', 'artist_name'),
                categoryOption: result.video_category,
                languageOption: multiSelectLabel(result.languages, 'id', 'name'),
                regionOption: multiSelectLabel(result.regions, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result.block_country, 'id', 'name'),
                availableCountryOption: multiSelectLabel(result.available_country, 'id', 'name'),
                relatedVideos: multiSelectLabel(result.related_videos, 'id', 'title'),
                relatedPlaylists: multiSelectLabel(result.playlist_videos, 'id', 'title'),
                writerOption: result.SongWriter,
                musicianOption: result.Musician,
                ageOption: result.Age_Restrict,
                albumOption: result.audio_albums,
                accessOption: result.user_access,
                iosOption: result?.InappPurchase,
                ppvPurchasePlans: result?.ppv_purchase_plans || [],
                // New Ideabiz purchase plans list (from edit API)
                ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
                classificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
                adminsetting: result?.adminsetting || {},
                videoSubtitle: result.video_subtitle,
                lyricsOption: response?.data?.sample_audio_lyrics ? response?.data?.sample_audio_lyrics : '',
                globalOption: result.ppv_gobal_price ? result.ppv_gobal_price : '',
                defaultCurrency: result?.DefaultCurrency,
                trailerOption: result?.trailer_type,
                googleProductIdPPV: result?.googleProductIdPPV || [],
                preAdvertisement: result?.pre_advertisement || [],
                midAdsCategory: result?.ads_category || [],
                postAdvertisement: result?.post_advertisement || [],
            }

            if (!defaultoptionslist.googleProductIdPPV || defaultoptionslist.googleProductIdPPV.length === 0) {
                try {
                    const createResponse = await axios.get(`${createApi}`, { headers: headers });
                    if (createResponse?.data?.googleProductIdPPV?.length) {
                        defaultoptionslist.googleProductIdPPV = createResponse.data.googleProductIdPPV;
                    }
                } catch (error) {
                    console.error("Error fetching fallback googleProductIdPPV:", error);
                }
            }
            setConvertPrice(prevState => {
                return {
                    ...prevState,
                    source_type: 1,
                    source_id: id,
                    PPVType: formData?.global_ppv,
                    PriceType: result?.DefaultCurrency?.code,
                    ActualPrice: formData?.ppv_price,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: result?.DefaultCurrency?.enable_secondary_currency == 1 && result?.DefaultCurrency?.enable_multi_currency != 1
                        ? (result?.ContentPriceRates || []).filter(item => {
                            const rawSec = result?.DefaultCurrency?.secondary_currencies;
                            const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
                            const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
                            return item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase());
                        })
                        : [...(result?.ContentPriceRates || [])]
                };
            });

            if (updatedFormData.content_classification) {
                const selectedTitles = updatedFormData.content_classification.split(',').map(item => item.trim());
                const selected = (defaultoptionslist?.classificationOption || []).filter(opt => selectedTitles.includes(opt.value));
                setSelectedClassifications(selected);
            }

            setDefaultOption((prev) => ({ ...prev, ...defaultoptionslist }));
            setDefaultEditOption(defaultoptionslist)

            // Debug PPV Purchase Plans data
            if (result?.ppv_purchase_plans || result?.adminsetting) {
                console.log('PPV Purchase Plans data loaded:', {
                    ppvPurchasePlans: result?.ppv_purchase_plans,
                    adminsetting: result?.adminsetting,
                    currentPpvPurchasePlansId: previousFormData?.ppv_purchase_plans_id
                });
            }

            setShowOverlay(false)
        } catch (error) {
            if (error?.response?.status == 404 || error?.response?.status == 500) {
                setFormData((prev) => ({ ...prev, error: error.response.data.message || "ID not found or api something went wrong." }))
            }
        }
        finally {
            setShowOverlay(false)
        }
    };

    const fetchCreateData = async () => {
        setShowOverlay(true)
        try {
            const response = await axios.get(`${createApi}`, { headers: headers });
            const result = response?.data;
            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result.video_artist, 'id', 'artist_name'),
                categoryOption: result.video_category,
                languageOption: multiSelectLabel(result.video_language, 'id', 'name'),
                regionOption: multiSelectLabel(result.regions, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result.Available_country, 'id', 'name'),
                availableCountryOption: multiSelectLabel(result.Available_country, 'id', 'name'),
                relatedVideos: multiSelectLabel(result.Related_videos, 'id', 'title'),
                relatedPlaylists: multiSelectLabel(result.all_video_playlist, 'id', 'title'),
                writerOption: result.SongWriter,
                musicianOption: result.Musician,
                ageOption: result.Age_Restrict,
                albumOption: result.audio_albums,
                accessOption: result.user_access,
                iosOption: result?.InappPurchase,
                ppvPurchasePlans: result?.ppv_purchase_plans || [],
                // New Ideabiz purchase plans list (from create API)
                ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
                googleProductIdPPV: result?.googleProductIdPPV || [],
                classificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
                adminsetting: result?.adminsetting || {},
                videoSubtitle: result.video_subtitle,
                lyricsOption: response?.data?.sample_audio_lyrics ? response?.data?.sample_audio_lyrics : '',
                globalOption: result.ppv_global_price ? result.ppv_global_price : '',
                videoTypeOption: result?.video_type,
                defaultCurrency: result?.DefaultCurrency,
                preAdvertisement: result?.pre_advertisement || [],
                midAdsCategory: result?.ads_category || [],
                postAdvertisement: result?.post_advertisement || [],
            }
            setDefaultOption(defaultoptionslist);

            // Debug PPV Purchase Plans data for create mode
            if (result?.ppv_purchase_plans || result?.adminsetting) {
                console.log('PPV Purchase Plans data loaded (create mode):', {
                    ppvPurchasePlans: result?.ppv_purchase_plans,
                    adminsetting: result?.adminsetting
                });
            }

            if (!id) {
                setCurrentType(result?.video_type[0]?.video_type)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowOverlay(false)
        }
    };

    const handleFileDelete = async () => {
        setShowOverlay(true);
        try {
            // Prepare request body for global delete with subtitle type
            const requestBody = {
                modelName: 'Videos',
                id: parseInt(id),
                deleteType: 'subtitles',
                subtitleLanguage: itemToDelete?.short_code // Delete specific language subtitle
            };

            const response = await axios.delete(globalDeleteApi, {
                headers: {
                    'Content-Type': 'application/json',
                    ...headers
                },
                data: requestBody // DELETE requests can have body data
            });

            const result = response?.data;
            if (result?.status) {
                setShowOverlay(false);
                setItemToDelete({});
                setWithOutRefresh(!withOutRefresh);
                toast.success(result?.message);
                closeModal();

                // Refresh the page data to update subtitle list
                if (editVideoStatus) {
                    await fetchData();
                }
            } else {
                toast.error(result?.message || 'Failed to delete subtitle');
                setShowOverlay(false);
                closeModal();
            }
        } catch (err) {
            const errorMessage = err?.response?.data?.message || 'Error deleting subtitle';
            console.error('Subtitle delete error:', err);
            toast.error(errorMessage);
            setShowOverlay(false);
            closeModal();
        }
    }

    const focusInput = (inputName) => {
        if (combinedRef.current[inputName]) {
            combinedRef.current[inputName].focus();
        }
    };

    const labelFetch = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.get(`${labelApi}`, { headers: headers });
            const result = response?.data?.label_management
            setLabelDisplay(result)
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleCovertPrice = async (value) => {
        let formIsValid = true
        if (!formData?.ppv_price || formData?.ppv_price == "0") {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                ppv_price: "ppv price cannot be empty.",
            }));
            combinedRef.current['ppv_price'].focus()
            formIsValid = false;
        }
        if (formIsValid) {
            const selectedCountryCode = defaultOption?.defaultCurrency?.code
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
                const rates = response.data.rates;
                let convertedPrices = allCurrencylistfromappi?.map(item => {
                    let country_name = item?.country;
                    let Symbol = item?.Symbol || item?.symbol;
                    let Code = item?.code;

                    const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
                    if (matchingCountry) {
                        country_name = matchingCountry?.country;
                        Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
                    }

                    return {
                        Code: Code,
                        Country: country_name,
                        Symbol: Symbol,
                        ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
                        price: value,
                        RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
                        editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        isEditable: true,
                    };
                });

                const cfg = getDefaultCurrencySetting();
                if (cfg?.enable_secondary_currency == 1 && cfg?.enable_multi_currency != 1) {
                    const rawSec = cfg?.secondary_currencies;
                    const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
                    const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
                    convertedPrices = convertedPrices.filter(item => item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase()));
                }

                setConvertPrice(prevState => ({
                    ...prevState,
                    source_type: 1,
                    source_id: id,
                    PPVType: formData?.global_ppv,
                    PriceType: selectedCountryCode,
                    ActualPrice: value,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: convertedPrices
                }));
            } catch (error) {
                console.error('Error fetching currency conversion rates:', error);
            }
        }
    };

    // Convert only between Currency Country (base) and Same Currency Country (e.g., Dubai)
    const handleSameCountryConvert = async (value) => {
        let formIsValid = true
        if (!formData?.ppv_price || formData?.ppv_price == "0") {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                ppv_price: "ppv price cannot be empty.",
            }));
            combinedRef.current['ppv_price']?.focus?.()
            formIsValid = false;
        }
        if (formIsValid) {
            const cfg = getDefaultCurrencySetting();
            const baseCode = cfg?.code;
            const baseCountry = cfg?.country;
            const baseSymbol = cfg?.symbol;
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${baseCode}`);
                const rates = response.data.rates;
                const targetCountryName = cfg?.same_currency_country; // expected 'Dubai'
                const targetRecord = allCurrencylistfromappi?.find(item => (
                    item?.country?.toLowerCase() === (targetCountryName || '').toLowerCase()
                ));
                const targetCode = targetRecord?.code;
                const targetSymbol = targetRecord?.Symbol || targetRecord?.symbol;

                const list = [];
                // Base row
                list.push({
                    Code: baseCode,
                    Country: baseCountry,
                    Symbol: baseSymbol,
                    ConvertedPriceRate: Number(value).toFixed(2),
                    price: value,
                    RateDifference: (0).toFixed(2),
                    editPrice: Number(value).toFixed(2),
                    ChangedPrice: Number(value).toFixed(2),
                    isEditable: true,
                });

                if (targetCode && targetCode !== baseCode) {
                    const convertedValue = (value * (rates[targetCode] || 0)).toFixed(2);
                    list.push({
                        Code: targetCode,
                        Country: targetCountryName,
                        Symbol: targetSymbol,
                        ConvertedPriceRate: convertedValue,
                        price: value,
                        RateDifference: (convertedValue - value).toFixed(2),
                        editPrice: convertedValue,
                        ChangedPrice: convertedValue,
                        isEditable: true,
                    });
                }

                setSameConvertPrice(prevState => ({
                    ...prevState,
                    source_type: 1,
                    source_id: id,
                    PPVType: formData?.global_ppv,
                    PriceType: baseCode,
                    ActualPrice: value,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: list
                }));
            } catch (error) {
                console.error('Error fetching currency conversion rates:', error);
            }
        }
    };

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;

        if (name == "skip_start_time" || name == "mid_advertisement_sequence_time" || name == "ssai_mid_ad_sequence_time" || name == "skip_end_time" || name == "skip_start_session" || name == "recap_start_session" || name == "recap_start_time" || name == "recap_end_time" || name == "url_linktym" || name == "urlEnd_linksec" || name == "free_duration_time" || name == "duration") {
            const formattedInput = value.replace(/\D/g, "");

            const formattedTime = formattedInput
                .replace(/^(\d{2})(\d{2})(\d{2})$/, "$1:$2:$3")
                .substr(0, 8);

            setFormData((prev) => ({
                ...prev,
                [name]: formattedTime,
            }));

            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            return
        }

        if (type === "radio") {
            if (["publish_now", "publish_later"].includes(name)) {
                setFormData(prev => ({
                    ...prev,
                    publish_type: checked ? name : ''
                }));
            } else if (name === "video_type") {
                setCurrentType(value);
            } else if (["global_ppv", "upload_single", "shorts_type"].includes(name)) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
        }

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
            if (name == "free_duration_status") {
                if (!checked) {
                    setFormDataError((prev) => ({
                        ...prev,
                        ['free_duration_time']: '',
                    }));
                }
            }

            if (name == "global_ppv") {
                if (checked) {
                    setFormData((prev) => ({
                        ...prev,
                        ['ppv_price']: defaultOption?.globalOption,
                    }));
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        ppv_price: "",
                    }));
                    if (globalPpvStatusActive?.PPV_Individual_Contents == 1) {
                        await handleCovertPrice(defaultOption?.globalOption)
                    }
                }
                else {
                    setFormData((prev) => ({
                        ...prev,
                        ['ppv_price']: editData?.ppv_price,
                    }));
                    if (globalPpvStatusActive?.PPV_Individual_Contents == 1) {
                        await handleCovertPrice(editData?.ppv_price)
                    }
                }
            }
        }

        if (type === 'text' || type == "time" || type == "date") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            if (name == "title") {
                setFormDataError((prev) => ({
                    ...prev,
                    ['slug']: '',
                }));
            }
        }


        if (name === 'brightcove_video_id' || name === 'brightcove_trailer_videos_id') {
            if (value === '' || /^\d+$/.test(value)) {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value
                }));
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: '',
                }));
            }
            return;
        }

        if (type === "number") {
            setFormData((prev) => ({
                ...prev,
                [name]: value.replace(/[^0-9.]/g, '')
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "datetime-local") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    };

    const handlePriceChangeInput = (e, index) => {
        const { value } = e.target;
        setConvertPrice(prevState => {
            const updatedRates = [...prevState.convertedPriceRates];
            updatedRates[index] = {
                ...updatedRates[index],
                ConvertedPriceRate: value
            };
            return {
                ...prevState,
                convertedPriceRates: updatedRates
            };
        });
    };

    const handleTagsChange = (newTags) => {
        const cleanedTags = (newTags || [])
            // A single entry may still contain commas (pasted "Mani, kandan" or
            // legacy data like "check,d") — split those into separate tags.
            .flatMap((tag) => String(tag ?? "").split(","))
            .map((tag) => tag.trim().toLowerCase())
            .filter((tag) => tag !== "")
            .filter((value, index, self) => self.indexOf(value) === index);
        setFormData((prevFormData) => ({
            ...prevFormData,
            search_tags: cleanedTags,
        }));
    };

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        console.log(`selectedOptions ${JSON.stringify(selectedOptions)}, and actionMeta ${JSON.stringify(actionMeta)}`);

        setFormData((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
        setFormDataError((prev) => ({
            ...prev,
            [actionMeta.name]: ""
        }))
    }

    // Load all playlists + the ones the current video already belongs to
    const fetchVideoPlaylists = async () => {
        if (!id) return;
        try {
            setVideoPlaylistLoading(true);
            const response = await axios.get(`${baseURL}/admin/video/playlist-for-video/${id}`, { headers });
            const data = response?.data?.data;
            if (response?.data?.status && data) {
                const options = Array.isArray(data.options) ? data.options : [];
                const selectedIds = Array.isArray(data.selected) ? data.selected : [];
                setVideoPlaylistOptions(options);
                setSelectedVideoPlaylists(options.filter((opt) => selectedIds.includes(opt.value)));
            }
        } catch (err) {
            console.error('Error fetching video playlists:', err);
        } finally {
            setVideoPlaylistLoading(false);
        }
    };

    // Only update local selection; the actual sync happens when the video is updated/saved
    const handleVideoPlaylistChange = (selectedOptions) => {
        setSelectedVideoPlaylists(selectedOptions || []);
    };

    // Persist the video's playlist membership. Called as part of the video update flow.
    const syncVideoPlaylists = async () => {
        if (!id) return;
        try {
            setVideoPlaylistSyncing(true);
            await axios.post(
                `${baseURL}/admin/video/playlist-sync-video/${id}`,
                { playlist_ids: selectedVideoPlaylists.map((opt) => opt.value) },
                { headers }
            );
        } catch (err) {
            console.error('Error syncing video playlists:', err);
            toast.error(err?.response?.data?.message || 'Failed to update video playlists');
        } finally {
            setVideoPlaylistSyncing(false);
        }
    };

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            if (name === 'video-image') {
                const modelName = "Videos";
                const imageFields = [];

                if (coverImageFile) {
                    formDataAdd.append('image', coverImageFile);
                    imageFields.push('image');
                }
                if (playerImageFile) {
                    formDataAdd.append('player_image', playerImageFile);
                    imageFields.push('player_image');
                }
                if (tvImageFile) {
                    formDataAdd.append('video_tv_image', tvImageFile);
                    imageFields.push('video_tv_image');
                }
                if (titleImageFile) {
                    formDataAdd.append('video_title_image', titleImageFile);
                    imageFields.push('video_title_image');
                }
                if (sliderImageFile) {
                    formDataAdd.append('slider_image', sliderImageFile);
                    imageFields.push('slider_image');
                }
                if (notificationImageFile) {
                    formDataAdd.append('push_notification_image', notificationImageFile);
                    imageFields.push('push_notification_image');
                }

                const orientationMap = {};
                imageFields.forEach((field) => {
                    if (selectedFieldConfigs[field]) {
                        orientationMap[field] = selectedFieldConfigs[field];
                    }
                });

                formDataAdd.append('modelName', modelName);
                formDataAdd.append('id', id);
                imageFields.forEach(field => {
                    formDataAdd.append('imageFields[]', field);
                });
                if (Object.keys(orientationMap).length > 0) {
                    formDataAdd.append('orientation_map', JSON.stringify(orientationMap));
                }
                // Apply per-upload cropping override when provided via props
                if (enableCroppingOverrideOnUpload !== null) {
                    formDataAdd.append('enable_cropping', enableCroppingOverrideOnUpload);
                }

                const response = await fetchRequest({
                    method: 'POST',
                    url: globalImageUplaodAPI(),
                    params: {},
                    data: formDataAdd,
                })

            }

            if (name === 'reels-image') {
                const formDataAdd = new FormData();
                formDataAdd.append('video_id', id);
                formDataAdd.append('reels_thumbnail', reelsImageFile);
                const response = await axios.post(`${reelsImageApi}`, formDataAdd, { headers });
            }

            if (name === 'paper') {
                formDataAdd.append('ePaper', pdfFile);
                formDataAdd.append('video_id', id);
                try {
                    const response = await axios.post(`${paperApi}`, formDataAdd, { headers });
                    console.log(response);
                    toast.success(response?.data?.message);
                } catch (error) {
                    console.log(error);
                    toast.error(error?.response?.data?.message);
                }
            }

            if (name === "subtitle") {
                // Check if there are any subtitle files to upload
                const hasSubtitleFiles = Object.keys(subtitleFile || {}).some(key => subtitleFile[key]);

                if (hasSubtitleFiles) {
                    const modelName = "Videos";
                    const subtitleFields = [];
                    const subtitleFilesToUpload = {};

                    // Prepare subtitle files for upload
                    Object.keys(subtitleFile).forEach(short_code => {
                        if (subtitleFile[short_code]) {
                            const videoData = defaultOption?.videoSubtitle.find(video => video.short_code === short_code);
                            if (videoData) {
                                // Use the short_code directly as the field name for backend processing
                                const fieldName = short_code;
                                formDataAdd.append(fieldName, subtitleFile[short_code]);
                                subtitleFields.push(fieldName);
                                subtitleFilesToUpload[fieldName] = {
                                    language: videoData.language,
                                    short_code: videoData.short_code
                                };
                            }
                        }
                    });

                    if (subtitleFields.length > 0) {
                        formDataAdd.append('modelName', modelName);
                        formDataAdd.append('id', id);
                        subtitleFields.forEach(field => {
                            formDataAdd.append('subtitleFields[]', field);
                        });

                        try {
                            console.log('Uploading subtitles with data:', {
                                modelName,
                                id,
                                subtitleFields,
                                hasFiles: Object.keys(subtitleFile).map(key => ({ key, hasFile: !!subtitleFile[key] }))
                            });

                            const response = await fetchRequest({
                                method: 'POST',
                                url: imageApi,
                                data: formDataAdd,
                            });

                            if (response?.status) {
                                toast.success(response?.message || "Subtitles uploaded successfully!");
                                // Clear uploaded subtitle files
                                Object.keys(subtitleFilesToUpload).forEach(fieldName => {
                                    const short_code = subtitleFilesToUpload[fieldName].short_code;
                                    setSubtitleFile((prev) => ({
                                        ...prev,
                                        [short_code]: ""
                                    }));
                                });
                            } else {
                                console.error("Failed to upload subtitles:", response?.message);
                                toast.error(response?.message || "Failed to upload subtitles");
                            }
                        } catch (error) {
                            console.error('Error uploading subtitles:', error);
                            toast.error(error?.response?.data?.message || "Error uploading subtitles");
                        }
                    }
                }
            }

            // Reset all file states after upload
            setCoverImageFile(null);
            setPlayerImageFile(null);
            setTvImageFile(null);
            setTitleImageFile(null);
            setSliderImageFile(null);
            setReelsImageFile(null);
            setPdfFile(null);
            setTrailerVideoUpload(null);
            setNotificationImageFile(null);

        } catch (err) {
            toast.error(err?.response?.data?.message);
        }
    };


    const handleSeoUpload = async (id) => {
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["Meta_description", "website_page_title", "website_URL"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            formDataAdd['video_id'] = id
            const response = await axios.post(`${seoApi}`, formDataAdd, { headers: headers });
            if (!response?.data?.status) {
                toast.error(response?.data?.message)
            }
        } catch (err) {
            console.error(err)
        }
    }

    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.title);
        }
    };

    const generateSlug = (title) => {
        const slug = slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };

    const handleInputKeyDowntitle = (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            if (!formData?.slug) {
                generateSlug(formData?.name);
            }
        }
    };


    const handleBlurTitleEdit = () => {
        generateSlug(formData?.slug);
    };


    const closeModal = () => {
        setModelClose(!closeModal);
        setShowModal(false);
    };

    const handleSubtitleDelete = (item) => {
        setModelClose(!modelClose);
        setItemToDelete(item)
    }

    useEffect(async () => {
        const ImageValidationresponse = await fetchRequest({
            method: 'GET',
            url: imageValidationApi,
            params: {},
            data: {},
        })
        setImagerequiredValidation(ImageValidationresponse?.Compress_image)
    }, [])


    const formValidation = async () => {
        let formIsValid = true;
        const validateTimeField = ({ field, label, requiredIf, focusField }) => {
            const value = formData?.[field];
            const rawDuration = value?.replace(/\D/g, '');

            if (requiredIf && (!value || rawDuration.length !== 6)) {
                setFormDataError(prev => ({
                    ...prev,
                    [field]: `${label} must be exactly 6 digits in HH:MM:SS format.`,
                }));
                combinedRef.current[focusField].focus();
                formIsValid = false;
                // return;
            }

            const hours = parseInt(rawDuration.slice(0, 2), 10);
            const minutes = parseInt(rawDuration.slice(2, 4), 10);
            const seconds = parseInt(rawDuration.slice(4, 6), 10);

            const isValidTime = (
                hours >= 0 && hours <= 23 &&
                minutes >= 0 && minutes <= 59 &&
                seconds >= 0 && seconds <= 59
            );

            if ((!isValidTime || (hours === 0 && minutes === 0 && seconds === 0)) && field != "skip_start_time" && field != "skip_start_session" && field != "recap_start_time" && field != "url_linktym") {
                setFormDataError(prev => ({
                    ...prev,
                    [field]: `${label} must be a valid time (not 00:00:00).`,
                }));
                combinedRef.current[focusField].focus();
                formIsValid = false;
            }
        };

        if (!formData?.title || formData.title?.trim() === '') {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                title: "Title cannot be empty or contain only spaces.",
            }));
            combinedRef.current['title']?.focus()
            formIsValid = false;
        }
        if (!formData?.slug || formData.slug?.trim() === '') {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug cannot be empty or contain only spaces.",
            }));
            combinedRef.current['slug']?.focus()
            formIsValid = false;
        }
        if (!formData.selected_categories || formData.selected_categories.length === 0) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                selected_categories: "Category cannot be empty.",
            }));
            (combinedRef.current['category_checkbox'] || combinedRef.current['selected_categories'])?.focus();
            formIsValid = false;
        }
        if (!formData?.age_restrict) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                age_restrict: "Age cannot be empty.",
            }));
            combinedRef.current['age_restrict']?.focus()
            formIsValid = false;
        }
        if (!formData?.access) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                access: "Choose the access.",
            }));
            combinedRef.current['access']?.focus()
            formIsValid = false;
        }
        if (!formData?.duration) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                duration: "Duration cannot be empty.",
            }));
            combinedRef.current['duration']?.focus();
            formIsValid = false;
            // return;
        }
        if (formData?.duration) {
            validateTimeField({
                field: 'duration',
                label: 'Duration',
                requiredIf: true,
                focusField: 'duration',
            });
        }

        if (formData?.free_duration_status) {
            if (!formData?.free_duration_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    free_duration_time: "Free Duration cannot be empty.",
                }));
                combinedRef.current['free_duration_time'].focus()
                formIsValid = false;
            } else {
                validateTimeField({
                    field: 'free_duration_time',
                    label: 'Free Duration Time',
                    requiredIf: true,
                    focusField: 'free_duration_time',
                });
            }
        }
        if (formData?.trailer_type === "mp4_url") {
            if (!formData?.trailer_mp4_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    trailer_mp4_url: "Please provide trailer mp4 url",
                }));
                formIsValid = false;
            } else if (!formData.trailer_mp4_url.toLowerCase().endsWith('.mp4')) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    trailer_mp4_url: "URL must end with .mp4 extension",
                }));
                formIsValid = false;
            }
            combinedRef.current['trailer_mp4_url'].focus();
        }

        if (formData?.trailer_type === "m3u8_url") {
            if (!formData?.trailer_m3u8_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    trailer_m3u8_url: "Please provide trailer m3u8 url",
                }));
                formIsValid = false;
            } else if (!formData.trailer_m3u8_url.toLowerCase().endsWith('.m3u8')) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    trailer_m3u8_url: "URL must end with .m3u8 extension",
                }));
                formIsValid = false;
            }
            combinedRef.current['trailer_m3u8_url'].focus();
        }

        if (formData?.trailer_type === "embed_code") {
            if (!formData?.trailer_embed_code?.trim()) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    trailer_embed_code: "Embed code cannot be empty.",
                }));
                combinedRef.current['trailer_embed_code'].focus();
                formIsValid = false;
                // return;
            }

            const embedCode = formData.trailer_embed_code?.trim();
            const youtubeEmbedRegex = /^https?:\/\/(?:www\.)?youtube?\.com\/embed\/[a-zA-Z0-9_-]+(?:\?[a-zA-Z0-9_=&-]+)*$/;

            if (!youtubeEmbedRegex.test(embedCode)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    trailer_embed_code: "Invalid YouTube embed URL. Format: https://www.youtube.com/embed/VIDEO_ID",
                }));
                combinedRef.current['trailer_embed_code'].focus();
                formIsValid = false;
                // return;
            }
        }

        if (formData?.skip_start_time) {
            validateTimeField({
                field: 'skip_start_time',
                label: 'Skip Start Time',
                requiredIf: true,
                focusField: 'skip_start_time',
            });
        }

        if (formData?.skip_end_time) {
            if (!formData?.skip_start_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    title: "Start Time should not be empty",
                }));
                combinedRef.current['title'].focus()
                formIsValid = false;
                // return;
            }
            validateTimeField({
                field: 'skip_end_time',
                label: 'Skip End Time',
                requiredIf: true,
                focusField: 'skip_end_time',
            });
        }

        if (formData?.recap_start_time) {
            validateTimeField({
                field: 'recap_start_time',
                label: 'Recap Start Time',
                requiredIf: true,
                focusField: 'recap_start_time',
            });
        }

        if (formData?.recap_end_time) {
            validateTimeField({
                field: 'recap_end_time',
                label: 'Recap End Session',
                requiredIf: true,
                focusField: 'recap_end_time',
            });
        }

        if (formData?.skip_start_session) {
            validateTimeField({
                field: 'skip_start_session',
                label: 'Skip Start Session',
                requiredIf: true,
                focusField: 'skip_start_session',
            });
        }

        if (formData?.recap_start_session) {
            validateTimeField({
                field: 'recap_start_session',
                label: 'Recap Start Session',
                requiredIf: true,
                focusField: 'recap_start_session',
            });
        }

        if (formData?.mid_advertisement_sequence_time) {
            validateTimeField({
                field: 'mid_advertisement_sequence_time',
                label: 'Mid Advertisement Sequence Time',
                requiredIf: true,
                focusField: 'mid_advertisement_sequence_time',
            });
        }

        if (formData?.ssai_mid_ad_sequence_time) {
            validateTimeField({
                field: 'ssai_mid_ad_sequence_time',
                label: 'SSAI Mid Ad Sequence Time',
                requiredIf: true,
                focusField: 'ssai_mid_ad_sequence_time',
            });
        }

        if (formData?.url_linktym) {
            validateTimeField({
                field: 'url_linktym',
                label: 'URL Link Time',
                requiredIf: true,
                focusField: 'url_linktym',
            });
        }

        if (formData?.urlEnd_linksec) {
            validateTimeField({
                field: "urlEnd_linksec",
                label: "URL End Time",
                requiredIf: true,
                focusField: "urlEnd_linksec",
            });
        }


        if (imagerequiredValidation?.videos === 1) {
            if ((formData?.Thumbnail?.includes('default_vertical_image.webp') || formData?.Thumbnail?.includes('uploads/settings/')) && !coverImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    image: "Please upload a thumbnail image.",
                }));
                combinedRef.current['image']?.focus();
                formIsValid = false;
            }

            if ((formData?.Player_thumbnail?.includes('default_horizontal_image.webp') || formData?.Player_thumbnail?.includes('uploads/settings/')) && !playerImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    player: "Please upload a player thumbnail image.",
                }));
                combinedRef.current['player']?.focus();
                formIsValid = false;
            }

            if ((formData?.TV_Thumbnail?.includes('default_horizontal_image.webp') || formData?.TV_Thumbnail?.includes('uploads/settings/')) && !tvImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    tv: "Please upload a TV thumbnail image.",
                }));
                combinedRef.current['tv']?.focus();
                formIsValid = false;
            }
        }


        if (imagerequiredValidation?.videos === 1) {
            if (formDataError?.image) {
                combinedRef.current['image'].focus()
                formIsValid = false;
            }
            if (formDataError?.player) {
                combinedRef.current['player'].focus()
                formIsValid = false;
            }
            if (formDataError?.tv) {
                combinedRef.current['tv'].focus()
                formIsValid = false;
            }
            if (formDataError?.title_image) {
                combinedRef.current['title_image'].focus()
                formIsValid = false;
            }
        }
        if (formData?.banner === 1) {
            if (!sliderImageFile && (!formData?.Slider_Thumbnail || formData?.Slider_Thumbnail === "" || formData?.Slider_Thumbnail?.includes('default_vertical_image.webp') || formData?.Slider_Thumbnail?.includes('uploads/settings/'))) {
                setFormDataError((prev) => ({
                    ...prev,
                    slider_image: "Please upload a slider image.",
                }));
                combinedRef.current['slider_image']?.focus();
                formIsValid = false;
            }
        }
        if (formData?.free_duration_status == 1) {
            console.log("formData?.free_duration_time", formData?.free_duration_time);
            const rawDuration = formData?.free_duration_time != null ? formData?.free_duration_time?.replace(/\D/g, '') : "";
            if (!formData?.free_duration_time || rawDuration.length < 6) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    free_duration_time: "Free Duration Time can't be empty",
                }));
                combinedRef.current['free_duration_time'].focus();
                formIsValid = false;
            } else {
                validateTimeField({
                    field: 'free_duration_time',
                    label: 'Free Duration Time',
                    requiredIf: true,
                    focusField: 'free_duration_time',
                });
            }
        }
        if (formData?.selected_categories?.length == 0) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                selected_categories: "Category cannot be empty.",
            }));
            (combinedRef.current['category_checkbox'] || combinedRef.current['selected_categories'])?.focus()
            formIsValid = false;
        }
        if (formData?.access == "ppv") {
            if (!formData?.ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    ppv_price: "PPV price cannot be empty.",
                }));
                // combinedRef.current['ppv_price'].focus()
                toast.error("PPV price cannot be empty.")
                formIsValid = false;
            }
        }
        if (formData?.mid_ads_category) {
            if (!formData?.mid_advertisement_sequence_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    mid_advertisement_sequence_time: "Sequence time cannot be empty.",
                }));
                combinedRef.current['mid_advertisement_sequence_time']?.focus()
                formIsValid = false;
            }
        }
        if (formData?.website_URL) {
            const urlPattern = /^https?:\/\/(?:[-\w.])+(?::[0-9]+)?(?:\/[^?\s]*)?(?:\?[^#\s]*)?(?:#[^\s]*)?$/i;
            if (!urlPattern.test(formData.website_URL)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    website_URL: "Please enter a valid URL format starting with http:// or https://",
                }));
                combinedRef.current['website_URL']?.focus();
                formIsValid = false;
            }
        }
        if (formData?.url_link) {
            const urlPattern = /^https?:\/\/(?:[-\w.])+(?::[0-9]+)?(?:\/[^?\s]*)?(?:\?[^#\s]*)?(?:#[^\s]*)?$/i;
            if (!urlPattern.test(formData.url_link)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    url_link: "Please enter a valid URL format starting with http:// or https://",
                }));
                combinedRef.current['url_link'].focus();
                formIsValid = false;
            }
        }
        if (formData?.publish_type == "publish_now") {
            if (!formData?.year) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    year: "Year cannot be empty.",
                }));
                combinedRef.current['year'].focus()
                formIsValid = false;
            }
        }
        if (formData?.publish_type == "publish_later") {
            if (!formData?.publish_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    publish_time: "Publish time cannot be empty.",
                }));
                combinedRef.current['publish_time'].focus()
                formIsValid = false;
            }
        }
        if (!formData?.title || formData?.title?.trim().length < 3 || formData?.title?.trim().length > 100) {
            toast.error("Title must be between 3 and 100 characters.");
            formIsValid = false;
        }

        if (!formData?.slug || formData?.slug?.trim().length < 3 || formData?.slug?.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            formIsValid = false;
        }

        return formIsValid;
    }

    const handlePPVPriceStore = async () => {
        let formIsValid = true
        if (!formData?.ppv_price || formData?.ppv_price == "0") {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                ppv_price: "ppv price cannot be empty.",
            }));
            combinedRef.current['ppv_price'].focus()
            formIsValid = false;
        }
        if (formIsValid) {
            setShowOverlay(true);
            try {
                // Send PPV conversion data along with the current Ideabiz plan ID
                const payload = {
                    ...convertPrice,
                    ideabiz_purchase_plans_id: formData?.ideabiz_purchase_plans_id || null,
                    google_product_id_ppvs_id: formData?.google_product_id_ppvs_id || null,
                };

                const response = await axios.post(`${updatePPV}`, payload, { headers: headers });
                const result = response?.data
                if (result?.status) {
                    setShowOverlay(false);
                    handlePriceModal()
                    toast.success(result?.message)
                }
                else {
                    setShowOverlay(false);
                    toast.error(result?.message)
                }
            }
            catch (err) {
                setShowOverlay(false);
                const errorMessage = err?.response?.data?.message
                toast.error(errorMessage)
                console.error("error", err)
            }
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["title", "slug", "year", "duration", "details", "description", "age_restrict", "content_classification", "rating", "recap_start_time", "recap_end_time", "recap_start_session", "skip_start_session", "skip_end_time", "skip_start_time", "url_link", "urlEnd_linksec", "url_linktym", "active", "banner", "slider_image", "featured", "is_shorts", "shorts_type", "enable_video_title_image", "free_duration_status", "free_duration_time", "mid_advertisement_sequence_time", "publish_type", "publish_time", "access", "ppv_price", "global_ppv", "ios_ppv_price", "ppv_purchase_plans_id", "ideabiz_purchase_plans_id", "google_product_id_ppvs_id", "brightcove_video_id", "brightcove_trailer_videos_id", "brightcove_account_id", "push_notification_enabled", "push_notification_title", "push_notification_description", "push_notification_publish_type", "push_notification_publish_time", "push_notification_source_type", "push_notification_source_type_name", "push_notification_slug", "is_ads", "ssai_enable", "ssai_mid_ad_sequence_time"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            formDataAdd['video_id'] = currentId?.moveId
            formDataAdd['artist_id'] = formData?.selected_artists?.map((option) => option?.value)
            formDataAdd['category_id'] = formData?.selected_categories?.map((option) => option?.value)
            formDataAdd['languages_id'] = formData?.selected_Languages?.map((option) => option?.value)
            formDataAdd['regions_id'] = formData?.selected_Regions?.map((option) => option?.value)
            formDataAdd['video_playlist_id'] = formData?.selected_playlist_videos?.map((option) => option?.value)
            formDataAdd['related_videos'] = formData?.selected_related_videos?.map((option) => option?.value)
            formDataAdd['search_tags'] = Array.isArray(formData?.search_tags) ? formData?.search_tags.join(', ') : '';
            formDataAdd['status'] = formData?.publish_type == "publish_now" ? 1 : 0;
            formDataAdd['publish_status'] = formData?.publish_type == "publish_now" ? 1 : 0;
            const response = await axios.post(`${storeApi}`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                // Custom Fields disabled - no additional fields to save
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'video', entityId: result?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                } if (coverImageFile || playerImageFile || tvImageFile || titleImageFile || sliderImageFile || notificationImageFile) {
                    await handleFileUpload(result?.id, 'video-image')
                }
                if (reelsImageFile) {
                    await handleFileUpload(result?.id, 'reels-image')
                }
                if (pdfFile) {
                    await handleFileUpload(result?.id, 'paper')
                }
                await handleFileUpload(result?.id, 'subtitle')
                await handleSeoUpload(result.id)
                setShowOverlay(false);
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
                navigate("/video-lists")
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleUpdate = async () => {
        setLoading(true);
        setShowOverlay(true)
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["title", "slug", "year", "duration", "details", "description", "age_restrict", "content_classification", "rating", "recap_start_time", "recap_end_time", "recap_start_session", "skip_start_session", "skip_end_time", "skip_start_time", "url_link", "urlEnd_linksec", "url_linktym", "active", "banner", "slider_image", "featured", "is_shorts", "shorts_type", "enable_video_title_image", "free_duration_status", "free_duration_time", "mid_advertisement_sequence_time", "publish_type", "publish_time", "access", "ppv_price", "global_ppv", "ios_ppv_price", "ppv_purchase_plans_id", "ideabiz_purchase_plans_id", "google_product_id_ppvs_id", "trailer_embed_code", "trailer_m3u8_url", "trailer_mp4_url", "trailer_type", "brightcove_video_id", "brightcove_trailer_videos_id", "brightcove_account_id", "push_notification_enabled", "push_notification_title", "push_notification_description", "push_notification_publish_type", "push_notification_publish_time", "push_notification_source_type", "push_notification_source_type_name", "push_notification_slug", "is_ads", "ssai_enable", "ssai_mid_ad_sequence_time"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }

            formDataAdd['pre_ads'] = formData?.pre_ads
            formDataAdd['post_ads'] = formData?.post_ads
            formDataAdd['mid_ads_category'] = formData?.mid_ads_category

            formDataAdd['artist_id'] = formData?.selected_artists?.map((option) => option?.value)
            formDataAdd['block_country_id'] = formData?.selected_blocked_country?.map((option) => option?.value)
            formDataAdd['available_countries_id'] = formData?.selected_available_country?.map((option) => option?.value)
            formDataAdd['category_id'] = formData?.selected_categories
            formDataAdd['languages_id'] = formData?.selected_Languages?.map((option) => option?.value)
            formDataAdd['regions_id'] = formData?.selected_Regions?.map((option) => option?.value)
            formDataAdd['video_playlist_id'] = formData?.selected_playlist_videos?.map((option) => option?.value)
            formDataAdd['related_videos'] = formData?.selected_related_videos?.map((option) => option?.value)
            formDataAdd['search_tags'] = Array.isArray(formData?.search_tags) ? formData?.search_tags.join(', ') : '';
            formDataAdd['status'] = formData?.publish_type == "publish_now" ? 1 : 0;
            formDataAdd['publish_status'] = formData?.publish_type == "publish_now" ? 1 : 0;

            const response = await axios.patch(`${updateApi}/${id}`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                // Custom Fields disabled - no additional fields to save
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'video', entityId: id, values: customFieldValues });
                } catch (e) {
                    toast.error(e.message || 'Failed to save additional fields');
                    setLoading(false);
                    return;
                } if (coverImageFile || playerImageFile || tvImageFile || titleImageFile || sliderImageFile || notificationImageFile) {
                    await handleFileUpload(result?.id, 'video-image')
                }
                if (reelsImageFile) {
                    await handleFileUpload(result?.id, 'reels-image')
                }
                if (pdfFile) {
                    await handleFileUpload(result?.id, 'paper')
                }
                await handleFileUpload(result?.id, 'subtitle')
                // if (trailerVideoUpload) {
                //   await handleFileUpload(result?.id, 'trailer')
                // }
                await handleSeoUpload(result.id)
                await syncVideoPlaylists()
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setLoading(false)
            setShowOverlay(false)
        }
    }
    const libraryChange = async (id) => {
        setActiveLibrary(id);
        setApiConfig((prev) => ({
            ...prev,
            body: {
                ...prev.body,
                libraryId: id,
            }
        }));
        if (storageSetting) {
            if (storageSetting?.bunny_cdn_storage === 1) {
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${cdnApis['bunny']?.libraryFind}`,
                    params: {},
                    data: {
                        videolibrary_id: id
                    },
                }).then((response) => {
                    if (response?.status) {
                        setLibraryVideos(multiSelectLabel(response?.streamvideos?.items, 'guid', 'title', 'videoUrl', 'videoLibraryId', 'availableResolutions', 'length'))
                    }
                }).catch((err) => {
                    toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
                })
            }
        }
    }

    const handleStore = async (e) => {
        e.preventDefault()
        if (await formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
        else {
            console.table("validation")
        }
    }


    useEffect(async () => {
        if (id) {
            await fetchData();
            setStep(2)
            if (editVideoRegex.test(location?.pathname)) {
                setStep(1)
                setEditVideoStatus(true)
                await fetchCreateData()
            }
        }
        else {
            await fetchCreateData()
        }
        labelFetch()
        setFormDataError({})
    }, [withOutRefresh, location]);

    // Load playlist memberships for the video being edited
    useEffect(() => {
        if (id) {
            fetchVideoPlaylists();
        }
    }, [id]);

    useEffect(async () => {
        if (!id) {
            setStep(1)
            setFormData((prev) => ({
                ...prev,
                error: ""
            }))
            await fetchCreateData()
        }
    }, [location])

    const handleToggleGalleryModel = (val) => {
        setGalleryModal(prev => !prev)
        if (val == "clear") {
            setSelectedIds([])
        }
        setGalleryModalSourceFillter(val)
    }
    const handleMoveVideo = async (selectIds) => {
        try {
            const formDataAdd = {};
            let response, result = null
            if (galleryModalSourceFillter == 1 && !editVideoStatus) {
                formDataAdd['video_ids'] = selectIds
                response = await axios.post(`${moveApi}`, formDataAdd, { headers: headers });
                result = response?.data;
            }
            if (galleryModalSourceFillter == 16 || editVideoStatus) {
                response = await axios.post(`${assingAPI}?video_id=${id}&library_id=${selectIds?.[0]}&updated_type=${editVideoStatus ? 'video' : 'trailer'}`, {}, { headers: headers });
                result = response?.data;
            }
            if (result?.status) {
                toast.success(result?.message)
                // console.log(result)
                // setFormData((prev) => ({
                //     ...prev,
                //     libraryMoveButton: result?.last_id
                // }))
                setSelectedIds([])
                handleToggleGalleryModel()
                if (galleryModalSourceFillter !== 16) {
                    navigate("/video-lists")
                }
            }
            else {
                toast.error(result?.message)
            }

        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }

    }
    const handleInputSearch = async (e) => {
        const { name, value, type } = e.target;

        if (type === "number") {
            if (/^\d*$/.test(value)) {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        } else if (name === 'brightcove_video_id') {
            if (/^\d*$/.test(value)) {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        }

        if (!value.trim()) {
            setFormData((prev) => ({
                ...prev,
                title_message: '',
                title_status: false
            }));
            return;
        }

        try {
            // Call the API to check title availability
            const availableTitle = await fetchRequest({
                method: 'POST',
                url: `${titleApi}`,
                params: {},
                data: {
                    unique_title: value
                }
            });

            setFormData((prev) => ({
                ...prev,
                title_message: availableTitle?.message,
                title_status: availableTitle?.status === true
            }));

        } catch (error) {
            console.error("Error checking title availability:", error);
            setFormData((prev) => ({
                ...prev,
                title_message: error?.response?.data?.message,
                title_status: false
            }));
        }
    };

    const handleClassificationChange = (selected) => {
        setSelectedClassifications(selected || []);
        const titles = (selected || []).map(item => item.value).join(',');
        setFormData(prev => ({ ...prev, content_classification: titles }));
    };

    useEffect(() => {
        if (editVideoRegex.test(location?.pathname)) {
            setEditVideoStatus(true)
        }
        else {
            setEditVideoStatus(false)
        }
    }, [editVideoRegex])



    // useEffect(async () => {
    //     if (!id) {
    //         if (storageSetting?.bunnyCdnStorage === 1) {
    //             try {
    //                 setLoading(true)
    //                 const responseBunnyLibrary = await fetchRequest({
    //                     method: 'GET',
    //                     url: `${cdnApis['bunny']?.libraryIndex}`,
    //                     params: {},
    //                     data: {},
    //                 })
    //                 if (responseBunnyLibrary?.status) {
    //                     const result = responseBunnyLibrary?.Items
    //                     setCloudLibrary(result)
    //                     setApiConfig((prev) => ({
    //                         ...prev,
    //                         api: `${uploadFileApi}${editVideoStatus ? `&action_type=updated&video_id=${id}` : '&action_type=created'}`,
    //                         body: {
    //                             ...prev.body,
    //                             libraryId: result?.[0]?.Id
    //                         }
    //                     }))
    //                     setActiveLibrary(result?.[0]?.Id)
    //                     const responseLibraryFind = await fetchRequest({
    //                         method: 'POST',
    //                         url: `${cdnApis['bunny']?.libraryFind}`,
    //                         params: {},
    //                         data: {
    //                             videolibrary_id: result?.[0]?.Id
    //                         },
    //                     }).then((responseLibraryFind) => {
    //                         if (responseLibraryFind?.status) {
    //                             setLibraryVideos(multiSelectLabel(responseLibraryFind?.streamvideos?.items, 'guid', 'title', 'videoUrl', 'videoLibraryId', 'availableResolutions', 'length'))
    //                         }
    //                     }).catch((err) => {
    //                         toast.error(err?.response?.data.message || err?.message || err?.response?.message)
    //                     })
    //                 }
    //             }
    //             catch (error) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     error: error?.response?.data?.error || error?.response?.data?.message || error.message || error || "Something wrong"
    //                 }))
    //             }
    //             finally {
    //                 setLoading(false)
    //             }
    //         }
    //     }
    // }, [storageLoading])


    useEffect(() => {
        if (storageSetting?.site_storage === 1 || storageSetting?.aws_storage === 1 || storageSetting?.bunnyCdnStorage === 1 || storageSetting?.sftp_storage === 1) {
            setApiConfig((prev) => ({
                ...prev,
                api: `${uploadFileApi}${editVideoStatus ? `&action_type=updated&video_id=${id}` : '&action_type=created'}`,
                body: {
                    ...prev.body,
                }
            }))
        }
    }, [editVideoStatus, storageSetting])

    useEffect(() => {
        if (storageSetting?.videocipher_storage === 1) {
            setApiConfig((prev) => ({
                ...prev,
                api: `${cdnApis["videocipher"]?.uploadApi}`,
                body: {
                    ...prev.body,
                }
            }))
        }
    }, [storageSetting])

    const openConfirmPOPUpVideoCipher = () => {
        if (!videoCipherIds?.length) {
            toast.info("Please select videos")
            return
        }
        if (siteTheme?.enable_ppv_based_resolution == 1) {
            setModelCloseVdoCipher(true)
        }
        else {
            setFormData((prev) => ({
                ...prev,
                upload_single: "0"
            }))
            videoCipherMoveURL()
        }
    }
    const videoCipherMoveURL = async () => {
        if (formData?.upload_single == null || formData?.upload_single == "") {
            toast.info("Choose one option from the checkboxes")
            return
        }
        setShowOverlay(true)
        const updatedList = videoCipherIds.map((item) => {
            return {
                title: item?.title,
                original_name: item?.title,
                resolutions: item?.resolution,
                videoCipherId: item?.id
            } || []
        })
        const response = await fetchRequest({
            method: 'POST',
            url: `${cdnApis['videocipher']?.moveApi}`,
            params: {},
            data: {
                videos: updatedList,
                upload_single: formData?.upload_single,
                source_type: 1,
                upload_source_type: 1
            },
        }).then((response) => {
            if (response?.status) {
                toast.success(response.message)
                setWithOutRefresh(prev => !prev)
                setVideoCipherIds([])
                setModelCloseVdoCipher(false)
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
        }).finally(() => {
            setShowOverlay(false)
        })
    }
    const handleRowSelect = (item) => {
        setVideoCipherIds((prev) => {
            const exists = prev.some((entry) => entry.id === item?.id);
            if (exists) {
                return prev.filter((entry) => entry.id !== item?.id);
            } else {
                let usedIndices, allIndices, availableIndex, resolution;
                if (siteTheme?.enable_ppv_based_resolution == 1) {
                    if (storageSetting?.videocipher_PPV_Resolution?.length === prev.length) {
                        toast.info("You have already selected videos for all available resolutions.");
                        return [...prev];
                    }
                    usedIndices = prev.map((entry) =>
                        storageSetting?.videocipher_PPV_Resolution?.findIndex(
                            (r) => r.label === entry.resolution
                        )
                    );
                    allIndices = [
                        ...Array(storageSetting?.videocipher_PPV_Resolution?.length || 0).keys(),
                    ];
                    availableIndex = allIndices.find((i) => !usedIndices.includes(i));

                    resolution =
                        storageSetting?.videocipher_PPV_Resolution?.[availableIndex]?.label || 'default';
                }
                else {
                    resolution = formData?.videocipher_resolution
                }

                return [...prev, { id: item?.id, resolution, title: item?.title }];
            }
        });

    };


    const handleLibraryChange = async (e, name) => {
        const files = e.target.files;
        if (!files?.length) return;
        const allowedTypes = /video\/(mp4|x-matroska|webm|quicktime|avi)/;
        for (let file of files) {
            if (!allowedTypes.test(file.type)) {
                toast.error(`Unsupported file format: ${file.name}`);
                e.target.value = ''; // Clear the file input
                return;
            }
        }

        const { site_storage_limit, site_storage_memory } = storageSetting;

        // Convert storage limit to bytes
        const memoryUnits = {
            MB: 1024 ** 2,
            GB: 1024 ** 3,
            TB: 1024 ** 4
        };

        const unitMultiplier = memoryUnits[site_storage_memory];
        if (!unitMultiplier) {
            alert(`Invalid storage unit: ${site_storage_memory}`);
            return;
        }

        const byteLimit = site_storage_limit * unitMultiplier;

        // Calculate total file size
        const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);

        if (totalSize > byteLimit) {
            alert(`Upload exceeds limit: ${site_storage_limit} ${site_storage_memory}`);
            e.target.value = null; // Reset file input
            return;
        }
        if (name === "videocipher") {
            await handleFileChangeProvider(e, apiConfig?.api, "video", { ...apiConfig?.body, upload_single: formData.upload_single, resolution: formData?.videocipher_resolution, title: siteTheme?.enable_ppv_based_resolution == 1 ? formData?.unique_title : "", resolutions: storageSetting?.videocipher_PPV_Resolution?.sort((a, b) => parseInt(a.label) - parseInt(b.label)), storage: storageSetting, siteTheme: siteTheme });
            e.target.value = null;
        }
        if (name == "trailer") {
            await handleFileChangeProvider(e, `${trailerApiLibrary}&video_id=${id}`, "trailer");
            // e.target.value = null;
        }
        if (name == "video") {
            await handleFileChangeProvider(e, apiConfig?.api, "video", { ...apiConfig.body });
            console.log(`yes add edit video..`);

            e.target.value = null;
        }
    }


    useEffect(() => {
        if (siteTheme?.enable_ppv_based_resolution == 0) {
            setFormData((prev) => ({
                ...prev,
                upload_single: 0
            }))
        }
    }, [siteTheme])
    useEffect(async () => {
        if (!id) {
            if (storageSetting?.videocipher_storage === 1) {
                try {
                    setLoading(true)
                    const responseVideoCipherLibrary = await fetchRequest({
                        method: 'GET',
                        url: `${cdnApis['videocipher']?.libraryIndex}`,
                        params: { page, limit },
                        data: {},
                    })
                    if (responseVideoCipherLibrary?.status) {
                        setPage(responseVideoCipherLibrary?.currentPage)
                        setTotal(responseVideoCipherLibrary?.count)
                        setLibraryVideos(responseVideoCipherLibrary?.rows)
                    }
                }
                catch (error) {
                    setFormData((prev) => ({
                        ...prev,
                        error: error?.response?.data?.error || error?.response?.data?.message || error.message || error || "Something wrong"
                    }))
                }
                finally {
                    setLoading(false)
                }
            }
        }
    }, [storageLoading])

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            libraryMoveButton: ""
        }))
    }, [currentType])

    if (showOverlay) {
        return <Defaultloadinggif className={`heightOnLoader`} />
    }

    const confirmToggle = (suggestedText) => {
        if (suggestedText && typeof suggestedText === 'string' && modalTarget) {
            setFormData(prev => ({ ...prev, [modalTarget]: suggestedText }));
        }
        setShowModal(false);
        setModalTarget(null);
    };

    const handleModal = (target) => {
        setModalTarget(target);
        if (target === "description") {
            setDefaultPrompt(`Give a short description about "${formData?.title || ""}"`);
        } else if (target === "details") {
            setDefaultPrompt(`Expand the content details for "${formData?.title || ""}"`);
        }
        setShowModal(true);
    };

    const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
        const trimmedPrompt = promptText?.trim();
        setLoading(true);
        try {
            const response = await axios.post(
                generateAISuggestionApi,
                { prompt: trimmedPrompt },
                { headers }
            );
            if (response.data?.status) {
                setLoading(false);
                setSuggestion(response.data.response);
            } else {
                alert(response.data.message || "Failed to generate suggestion.");
            }
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Token expired or invalid. Please login again.");
            } else {
                console.error(error);
                alert("Error generating suggestion.");
            }
        }
    };

    const handleCategoryModalOpen = () => setCategoryModal(true);
    const handleCategoryModalClose = () => setCategoryModal(false);
    const handleCategoryCreated = (newId, newName) => {
        if (newId && newName) {
            setDefaultOption(prev => ({
                ...prev,
                categoryOption: [...(prev?.categoryOption || []), { value: newId, label: newName }]
            }));
            setFormData(prev => {
                const curr = Array.isArray(prev?.selected_categories) ? prev.selected_categories : [];
                return { ...prev, selected_categories: [...curr, { value: newId, label: newName }] };
            });
        }
        setCategoryModal(false);
    };

    const handleAgeModalOpen = () => setAgeModal(true); const handleAgeModalClose = () => setAgeModal(false);

    const handleClassificationModalOpen = () => setClassificationModal(true);
    const handleClassificationModalClose = () => setClassificationModal(false);

    const handleAgeCreated = (newAge) => {
        if (newAge) {
            setDefaultOption(prev => ({
                ...prev,
                ageOption: [...(prev?.ageOption || []), { age: newAge }]
            }));
            setFormData(prev => ({ ...prev, age_restrict: newAge }));
        }
        setAgeModal(false);
    };

    const handleArtistModalOpen = () => setArtistModal(true);
    const handleArtistModalClose = () => setArtistModal(false);
    const handleArtistCreated = (newId, newName) => {
        if (newId && newName) {
            setDefaultOption(prev => ({
                ...prev,
                artistsOption: [...(prev?.artistsOption || []), { value: newId, label: newName }]
            }));
            setFormData(prev => {
                const curr = Array.isArray(prev?.selected_artists) ? prev.selected_artists : [];
                return { ...prev, selected_artists: [...curr, { value: newId, label: newName }] };
            });
        }
        setArtistModal(false);
    }

    const handleClassificationCreated = async (newClassification) => {
        // Refresh the options list first
        if (editVideoStatus) {
            await fetchData();
        } else {
            await fetchCreateData();
        }

        // Auto-select the newly created classification
        const newOption = { value: newClassification, label: newClassification };
        setSelectedClassifications(prev => {
            const exists = prev.find(opt => opt.value === newClassification);
            if (!exists) {
                return [...prev, newOption];
            }
            return prev;
        });

        setFormData(prev => {
            const currentClassifications = prev.content_classification ? prev.content_classification.split(',').map(c => c.trim()) : [];
            if (!currentClassifications.includes(newClassification)) {
                const updated = [...currentClassifications, newClassification].join(',');
                return { ...prev, content_classification: updated };
            }
            return prev;
        });

        setClassificationModal(false);
    }

    const handleLanguageModalOpen = () => setLanguageModal(true);
    const handleLanguageModalClose = () => setLanguageModal(false);
    const handleLanguageCreated = (newId, newName) => {
        if (newId && newName) {
            setDefaultOption(prev => ({
                ...prev,
                languageOption: [...(prev?.languageOption || []), { value: newId, label: newName }]
            }));
            setFormData(prev => {
                const curr = Array.isArray(prev?.selected_Languages) ? prev.selected_Languages : [];
                return { ...prev, selected_Languages: [...curr, { value: newId, label: newName }] };
            });
        }
        setLanguageModal(false);
    };



    function CategoryMultiSelect({ options, value = [], onChange }) {
        const [open, setOpen] = React.useState(false);
        console.log(`category options ${JSON.stringify(options, null, 2)}`);

        useEffect(() => {
            function handleClickOutside(event) {
                const box = combinedRef.current.category_checkbox;
                if (box && !box.contains(event.target)) {
                    setOpen(false);
                }
            }

            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }, []);

        const toggle = (id) => {
            if (value.includes(id)) {
                onChange(value.filter(v => v !== id));
            } else {
                onChange([...value, id]);
            }
        };

        return (
            <div ref={(el) => (combinedRef.current.category_checkbox = el)} className="w-100" style={{ position: 'relative' }}>

                <div
                    className="custom-input-border custom-input theme-text-color cursor-pointer mb-3"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen(o => !o);
                    }}
                >
                    {value.length
                        ? `${value.length} categories selected`
                        : "Choose categories"}
                </div>

                {open && (
                    <div
                        className="border shadow"
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            zIndex: 9999,
                            backgroundColor: '#fff',
                            maxHeight: '300px',
                            overflowY: 'auto',
                            marginTop: '4px',
                        }}
                    >
                        <TreeCheckbox
                            options={options}
                            selected={value}
                            onToggle={toggle}
                            level={0}
                        />
                    </div>
                )}
            </div>
        );
    }


    function TreeCheckbox({ options, selected, onToggle, level }) {
        return (
            <ul>
                {options.map(item => (
                    <li key={item.id}>
                        <label
                            className="custom-input theme-text-color d-flex items-center gap-2 py-1 cursor-pointer"
                            style={{ paddingLeft: level * 16 }}
                        >
                            <input
                                type="checkbox"
                                checked={selected.includes(item.id)}
                                onChange={() => onToggle(item.id)}
                            />
                            {item.name}
                        </label>

                        {item.sub_category?.length > 0 && (
                            <TreeCheckbox
                                options={item.sub_category}
                                selected={selected}
                                onToggle={onToggle}
                                level={level + 1}
                            />
                        )}
                    </li>
                ))}
            </ul>
        );
    }


    return (
        <React.Fragment>
            {storageSetting?.site_storage === 1 && <StorageLimitModal open={showStorageModal} onClose={handleStorageModalClose} />}
            {(!transcodingEnabled && !hideTranscodingBanner) && (
                <div className="alert alert-warning d-flex align-items-center justify-content-between mt-2">
                    <div className="d-flex align-items-center">
                        <IoIosInformationCircleOutline size={20} className="me-2" />
                        <div>
                            <div className="fw-semibold">Enable Transcoding for seamless uploads</div>
                            <small className="text-muted">Turn on transcoding to ensure smooth processing and playback of uploaded videos.</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Link
                            to="/site/transcoding-setting"
                            className="link-primary fw-semibold text-decoration-underline"
                        >
                            Go to Transcoding Settings
                        </Link>


                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setHideTranscodingBanner(true)} aria-label="Dismiss">
                            <IoClose />
                        </button>
                    </div>
                </div>
            )}
            {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={galleryModalSourceFillter} saveAction={handleMoveVideo} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={(galleryModalSourceFillter == 1 && "Select Video" || galleryModalSourceFillter == 16 && "Select Trailer")} />}
            {pricemodel &&
                <div class={`modal  packageModel fade ${pricemodel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
                    <div className="modal-dialog modal-large p-4" role="document">
                        <div className="modal-content  theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button id="ppvCloseModelUp" type="button" className='bg-transparent' onClick={handlePriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                {/* <div className="d-flex justify-content-between mb-2 col-8 me-auto">
                                    <div className="col-12 col-md-6 pe-2">
                                        <MessageSubHeading text={labelDisplay?.[64]?.sub_title} />
                                    </div>
                                    <div className="col-12 col-md-6 ps-2 text-end">
                                        <AdminSwitch id="globalPPVCheckbox" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                                    </div>
                                </div> */}

                                <div className="row mx-0 align-items-start mb-3 ">
                                    <div className="col-12 col-md-4 ps-0 ">
                                        <MessageLabel text={`${formData?.global_ppv == 0 ? labelDisplay?.[67]?.title : labelDisplay?.[66]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                        <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="number" id="countryPPVPrice" data-test-id="countryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                    </div>
                                    <div className="col-12 col-md-4 ">
                                        <MessageLabel text={`${labelDisplay?.[65]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                        <AdminCustomSelect id="countryPPVIOSPrice" data-test-id="countryPPVIOSPrice" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                    </div>
                                    {/* Ideabiz Purchase Plans - show only when data is available */}
                                    {Array.isArray(defaultOption?.ideabizPPVPurchase) && defaultOption.ideabizPPVPurchase.length > 0 && (
                                        <div className="col-12 col-md-4 ">
                                            <MessageLabel text={`Idea Biz (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                            <AdminCustomSelect
                                                id="ideabiz-purchase-plans"
                                                data-test-id="ideabiz-purchase-plans"
                                                name="ideabiz_purchase_plans_id"
                                                // We now store ideabiz_purchase_plans_id as a plain ID (number)
                                                value={formData?.ideabiz_purchase_plans_id || ''}
                                                onChange={(e) => handleIdeabizPlanSelect(e.target.value)}
                                                options={defaultOption.ideabizPPVPurchase.map((plan) => ({
                                                    name: plan?.plan_name || plan?.name || `Plan ${plan?.id}`,
                                                    value: plan?.id,
                                                }))}
                                                defaultOptionName="Choose Idea Biz plan"
                                            />
                                        </div>
                                    )}
                                    {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                                        <div className="col-12 col-md-4 ">
                                            <MessageLabel text={`Google Purchase (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                            <AdminCustomSelect
                                                id="google-product-ppvs"
                                                data-test-id="google-product-ppvs"
                                                name="google_product_id_ppvs_id"
                                                value={formData?.google_product_id_ppvs_id || ''}
                                                onChange={(e) => handleGoogleProductPlanSelect(e.target.value)}
                                                options={defaultOption.googleProductIdPPV.map((plan) => ({
                                                    name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                                                    value: plan?.id,
                                                }))}
                                                defaultOptionName="Choose Google Purchase"
                                            />
                                        </div>
                                    )}
                                    <div className="col-12 col-md-3 pe-0 align-self-center mt-4">
                                        <AdminCustomButton id="covertPriceButton" className='px-3 py-1 m-0' saveMethod={() => handleCovertPrice(formData?.ppv_price)} saveText='Convert' />
                                    </div>
                                </div>

                                <div className="priceTable rounded-3  ">
                                    <table class="table rounded-3  position-relative">
                                        <thead className="theme-bg-color-secondary  z-index-1">
                                            <tr>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                                                {/* <th scope="col">Converted IOS Price</th> */}
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                                                    <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                                                    <td className=""> <AdminCustomInput id="priceChangeInput" data-test-id={`price-change-input-${index}-${item?.Code}`} isReadonly={formData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                                                    <td className="">{item?.RateDifference}</td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer  border-0">
                                <button id="ppvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handlePriceModalClose} ><MessageBox text="Cancel" /> </button>
                                <AdminCustomButton id="countryPriceSubmitButton" className='px-3 py-1 m-0 ' saveMethod={handlePPVPriceStore} saveText='Submit & Reload' />
                            </div>
                        </div>
                    </div>
                </div>}
            {samePriceModel &&
                <div class={`modal  packageModel fade ${samePriceModel && 'd-block show'}`} id="sameCountryPPVModal" tabIndex="-1" role="dialog" aria-labelledby="sameCountryPPVModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content  theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Same Country Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent' onClick={handleSameCountryPriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mx-0 align-items-start mb-3 ">
                                    <div className="col-12 col-md-5 ps-0 ">
                                        <MessageLabel text={`Base Price (${(defaultOption?.defaultCurrency?.symbol || getDefaultCurrencySetting()?.symbol)} ${(defaultOption?.defaultCurrency?.code || getDefaultCurrencySetting()?.code)}) - ${(defaultOption?.defaultCurrency?.country || getDefaultCurrencySetting()?.country)}`} />
                                        <AdminCustomInput type="number" id="sameCountryPPVPrice" data-test-id="sameCountryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                    </div>
                                    <div className="col-12 col-md-5 ">
                                        <MessageLabel text={`IOS Price (${(defaultOption?.defaultCurrency?.symbol || getDefaultCurrencySetting()?.symbol)} ${(defaultOption?.defaultCurrency?.code || getDefaultCurrencySetting()?.code)}) - ${(defaultOption?.defaultCurrency?.country || getDefaultCurrencySetting()?.country)}`} />
                                        <AdminCustomSelect id="sameCountryIOSPrice" data-test-id="sameCountryIOSPrice" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                    </div>
                                    <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                                        <AdminCustomButton className='px-3 py-1 m-0' saveMethod={() => handleSameCountryConvert(formData?.ppv_price)} saveText='Convert' />
                                    </div>
                                </div>
                                <div className="priceTable rounded-3  ">
                                    <table class="table rounded-3  position-relative">
                                        <thead className="theme-bg-color-secondary  z-index-1">
                                            <tr>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sameConvertPrice?.convertedPriceRates?.length ? sameConvertPrice?.convertedPriceRates.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                                                    <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                                                    <td className=""> <AdminCustomInput data-test-id={`same-price-change-input-${index}-${item?.Code}`} isReadonly={formData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={() => { }} placeHolder={"Converted price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                                                    <td className="">{item?.RateDifference}</td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan={4} className="errorred text-center">* Please update the pricing for Base and Same Currency country.</td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer  border-0">
                                <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handleSameCountryPriceModalClose} ><MessageBox text="Cancel" /> </button>
                                <AdminCustomButton className='px-3 py-1 m-0 ' saveMethod={async () => {
                                    setShowOverlay(true);
                                    try {
                                        const response = await axios.post(`${updatePPV}`, sameConvertPrice, { headers: headers });
                                        const result = response?.data
                                        if (result?.status) {
                                            setShowOverlay(false);
                                            setSamePriceModel(false)
                                            toast.success(result?.message)
                                        } else {
                                            setShowOverlay(false);
                                            toast.error(result?.message)
                                        }
                                    } catch (err) {
                                        setShowOverlay(false);
                                        const errorMessage = err?.response?.data?.message
                                        toast.error(errorMessage)
                                    }
                                }} saveText='Submit & Reload' />
                            </div>
                        </div>
                    </div>
                </div>}
            {categoryModal && (
                <div class={`modal packageModel fade ${categoryModal && 'd-block show'}`} id="videoCategoryModal" tabIndex="-1" role="dialog" aria-labelledby="videoCategoryModalLabel" >
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Video Category" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={handleCategoryModalClose} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <AddManagevideocategories isModal={true} forceCreate={true} onSuccess={handleCategoryCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {ageModal && (
                <div class={`modal packageModel fade ${ageModal && 'd-block show'}`} id="videoAgeModal" tabIndex="-1" role="dialog" aria-labelledby="videoAgeModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Age" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={handleAgeModalClose} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <AddManageAge isModal={true} onSuccess={handleAgeCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {classificationModal && (
                <div class={`modal packageModel fade ${classificationModal && 'd-block show'}`} id="videoClassificationModal" tabIndex="-1" role="dialog" aria-labelledby="videoClassificationModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Content Classification" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={handleClassificationModalClose} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <ContentClassification isModal={true} onSuccess={handleClassificationCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {languageModal && (
                <div class={`modal packageModel fade ${languageModal && 'd-block show'}`} id="videoLanguageModal" tabIndex="-1" role="dialog" aria-labelledby="videoLanguageModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Language" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={handleLanguageModalClose} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <LanguageAddUpdate isModal={true} forceCreate={true} onSuccess={handleLanguageCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {artistModal && (
                <div class={`modal packageModel fade ${artistModal && 'd-block show'}`} id="videoArtistModal" tabIndex="-1" role="dialog" aria-labelledby="videoArtistModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Artist" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={handleArtistModalClose} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <ArtistAddUpdate isModal={true} forceCreate={true} onSuccess={handleArtistCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {modelCloseVdoCiPher && <div class={`modal  packageModel fade ${modelCloseVdoCiPher && 'd-block show'}`} id="videoCipherUploadSingleModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content  theme-bg-color ">
                        <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text={`${"Confirmation for video resolution updated"}`} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button type="button" className='bg-transparent theme-text-color' onClick={() => setModelCloseVdoCipher(false)} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            <MessageBox classname="theme-text-color " text="If you select the same video with different resolutions, please check [Update Single]. if you select different videos with different resolutions, please check [Update Multiple]." />
                            <div className='d-flex align-items-center  gap-3 mt-3'>
                                <div className='d-flex align-items-center gap-2'>
                                    <AdminCheckBox id="uploadSingle" name="upload_single" type={"radio"} value={1} checked={formData?.upload_single == 1} onChange={handleInput} />
                                    <MessageBox text="Update Single" />
                                </div>
                                <div className='d-flex align-items-center gap-2'>
                                    <AdminCheckBox id="uploadMultiple" name="upload_single" type={"radio"} value={0} checked={formData?.upload_single == 0} onChange={handleInput} />
                                    <MessageBox text="Update Multiple" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer  border-0">
                            <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => setModelCloseVdoCipher(false)} id="closeModal"><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton id="videoCipherProceedURLButton" className='px-3 py-1 m-0 ' saveMethod={videoCipherMoveURL} saveText={"Proceed"} ></AdminCustomButton>
                        </div>
                    </div>
                </div>
            </div>}
            {showOverlay && (<Response_Processing></Response_Processing>)}
            {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleFileDelete} buttonText={'custom'} message={`Are you sure you want to delete this video ${itemToDelete?.language} subtitle?`} />}
            {<AdminBackNavigation path={`${editVideoStatus ? `/edit-video/${id}` : "/video-lists"}`} text="Back" />}

            {!formData?.error ? <>
                {step == 1 &&
                    <React.Fragment>
                        <div className="rounded-5 mb-4 theme-bg-color p-5">
                            {storageSetting?.bunny_cdn_storage === 1 ? <div className='mb-4'>  <MessageHeading text={"Bunny CDN Stream"} padding border />
                                <div className='d-flex align-items-center flex-wrap gap-4'>
                                    {cloudLibrary?.map((item, index) => (
                                        <div className='col-3' onClick={() => libraryChange(item?.Id)} id="librarySelect">
                                            <div className={`${activeLibrary == item?.Id ? 'theme-button-bg-color' : 'theme-bg-color-secondary'}  p-3 rounded-3`}>
                                                <MessageLabel text={item?.Name} noMargin className={`mb-2 ${activeLibrary == item?.Id ? 'theme-button-text-color' : ''}`} />
                                                <MessageSubHeading text={`${item?.VideoCount} Videos`} loadingHide className={`mb-4 ${activeLibrary == item?.Id ? 'theme-button-text-color' : ''}`} />
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div>
                                                        <MessageLabel text={`Storage `} noMargin className={`mb-2 ${activeLibrary == item?.Id ? 'theme-button-text-color' : ''}`} />
                                                        <MessageSubHeading text={formatFileSize(item?.StorageUsage)} className={`mb-4 ${activeLibrary == item?.Id ? 'theme-button-text-color' : ''}`} />
                                                    </div>
                                                    <div>
                                                        <MessageLabel text={"Traffic"} noMargin className={`${activeLibrary == item?.Id ? 'theme-button-text-color' : ''} mb-2`} />
                                                        <MessageSubHeading text={formatFileSize(item?.TrafficUsage)} className={`${activeLibrary == item?.Id ? 'theme-button-text-color' : ''} mb-4`} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div> : ""}
                            {formData?.video_type !== "m3u8_url" && <MessageHeading text={`Upload to ${storageSetting?.site_storage === 1 ? "Video" : storageSetting?.aws_storage === 1 ? "Aws Storage" : storageSetting?.bunny_cdn_storage === 1 ? "CDN" : storageSetting?.flussonic_storage === 1 ? "Flussonic Storage" : storageSetting?.videocipher_storage === 1 ? "Videocipher Storage" : ""} `} padding border noMargin />}
                            {formData?.video_type == "m3u8_url" && <MessageHeading text="Bunny CDN Move To Site Storage" padding border />}
                            <>

                                <div className="pt-4 px-3">
                                    <div className="radio-options text-center  d-flex flex-wrap  justify-content-center ">
                                        {defaultOption?.videoTypeOption?.map((data, index) => (
                                            <div key={index} className={`col-md-2 col-6 mb-2 text-md-center text-start mb-3 `}>
                                                <div className="d-flex align-items-center ">
                                                    <AdminCheckBox id="videoTypeOptionRadio" data-test-id={`video-type-option-${data?.video_type}`} type={"radio"} className={""} name="video_type" value={data?.video_type} checked={currentType == data?.video_type} onChange={handleInput} />
                                                    <MessageLabel text={data?.name} className="ms-1 mb-md-0 mb-0 " noMargin />
                                                </div>
                                            </div>
                                        ))}
                                        {
                                            storageSetting?.videocipher_storage == 1 ?
                                                <>
                                                    <div key={""} className={`col-md-2 col-6 mb-2 text-md-center text-start mb-3 `}>
                                                        <div className="d-flex align-items-center ">
                                                            <AdminCheckBox id="videoUploadButton" data-test-id="video-type-option-videocipher_url" type={"radio"} className={""} name="video_type" value={'videocipher_url'} checked={currentType == 'videocipher_url'} onChange={handleInput} />
                                                            <MessageLabel text={"Import  Videocipher"} className="ms-1 mb-md-0 mb-0 " noMargin />
                                                        </div>
                                                    </div>
                                                    <div key={""} className={`col-md-2 col-6 mb-2 text-md-center text-start mb-3 `}>
                                                        <div className="d-flex align-items-center ">
                                                            <AdminCheckBox id="videoURLMoveButton" data-test-id="video-type-option-library" type={"radio"} className={""} name="video_type" value={'library'} checked={currentType == 'library'} onChange={handleInput} />
                                                            <MessageLabel text={"Import Site Storage"} className="ms-1 mb-md-0 mb-0 " noMargin />
                                                        </div>
                                                    </div>
                                                </> : ""}
                                        {storageSetting?.brightcove_storage == 1 ?
                                            <div key={""} className={`col-md-2 col-6 mb-2 text-md-center text-start mb-3 `}>
                                                <div className="d-flex align-items-center ">
                                                    <AdminCheckBox id="videoBrightcoveButton" data-test-id="video-type-option-brightcove" type={"radio"} className={""} name="video_type" value={'brightcove'} checked={currentType == 'brightcove'} onChange={handleInput} />
                                                    <MessageLabel text={"Brightcove"} className="ms-1 mb-md-0 mb-0 " noMargin />
                                                </div>
                                            </div> : ""}
                                    </div>
                                </div>
                                <div className="px-3 pb-3">
                                    {(currentType == "mp4_video_upload" && storageSetting?.videocipher_storage !== 1) ?
                                        <>
                                            <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                                                <div className="dropZoneText d-flex align-items-center justify-content-center">
                                                    <MessageBox text="Drag and drop video files here, or click to select files" classname="theme-text-color" />
                                                </div>
                                                <input id="videoUploadFile" data-test-id="videoUploadFile" type="file" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" className="w-100 h-100" multiple onChange={(e) => { handleLibraryChange(e, "video") }} />
                                            </div>
                                            <MessageSubHeading className={"text-center mt-4"} text={`Max Upload Limit (${storageSetting?.site_storage_limit} ${storageSetting?.site_storage_memory})`} />
                                            <AdminCustomButton saveMethod={() => handleToggleGalleryModel(1)} saveText="Choose from library" className="mt-3" />
                                        </> : ""}
                                    {(currentType == "mp4_video_upload" && storageSetting?.videocipher_storage == 1) ?
                                        <>
                                            <div className="d-flex align-items-center gap-2 my-4">
                                                <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"VideoCipher storage does not support video resolution transcoding. Therefore, videos need to be transcoded to the desired resolution before uploading"} />
                                            </div>
                                            <div className="d-flex align-items-center gap-2 my-4">
                                                <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"The title is required for different resolutions of a single video. In the future, if any resolutions are updated or added, the title will still be needed for identification."} />
                                            </div>
                                            <AdminCustomInput type="text" id="uniqueTitle" data-test-id="uniqueTitle" name="unique_title" value={formData?.unique_title} onChange={(e) => handleInputSearch(e)} placeHolder={"Enter the title"} ref={(el) => (combinedRef.current.unique_title = el)} error={formDataError?.unique_title} />

                                            <span>{formData?.title_message}</span>


                                            {formData?.title_status ?
                                                <>

                                                    {siteTheme?.enable_ppv_based_resolution === 1 ? <div className="my-3">
                                                        <div className="d-flex align-items-center gap-2 my-4">
                                                            <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"If you select the same video with different resolutions, please check (Update Single)."} />
                                                        </div>
                                                        <div className="d-flex align-items-center gap-2 my-4">
                                                            <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"if you select different videos with different resolutions, please check (Update Multiple)."} />
                                                        </div>
                                                        <div className='d-flex align-items-center  gap-3 mt-3'>
                                                            <div className='d-flex align-items-center gap-2'>
                                                                <AdminCheckBox id="uploadSingleEnable" name="upload_single" type={"radio"} value={1} checked={formData?.upload_single == 1} onChange={handleInput} />
                                                                <MessageBox text="Update Single" />
                                                            </div>
                                                            <div className='d-flex align-items-center gap-2'>
                                                                <AdminCheckBox id="uploadMultipleEnable" name="upload_single" type={"radio"} value={0} checked={formData?.upload_single == 0} onChange={handleInput} />
                                                                <MessageBox text="Update Multiple" />
                                                            </div>
                                                        </div>
                                                    </div> : ""}


                                                    {formData?.upload_single != null ?
                                                        <>
                                                            {siteTheme?.enable_ppv_based_resolution === 1 ?
                                                                <>
                                                                    <div className="d-flex align-items-center gap-2 my-4">
                                                                        <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"* Please upload the correct resolution videos one by one based on the resolutions listed below"} />
                                                                    </div>
                                                                    <div className='d-flex align-items-center my-3'>  {storageSetting?.videocipher_PPV_Resolution?.sort((a, b) => parseInt(a.label) - parseInt(b.label))?.map((item) => <span className={`custom-input-border  px-2 py-1 ${videoCipherIds?.some((entry) => entry?.resolution == item?.label) && "theme-button-bg-color theme-button-text-color"}`}>{item?.label}</span>)}</div>
                                                                </>
                                                                :
                                                                <>
                                                                    <p className=''>Please select the one  resolution</p>
                                                                    <AdminCustomSelect id="resolutionSelect" data-test-id="resolutionSelect" name="videocipher_resolution" className="d-block w-25 mt-3" value={formData?.videocipher_resolution || 0} onChange={handleInput} ref={(el) => (combinedRef.current.videocipher_resolution = el)} options={storageSetting?.transcoding_resolution} error={formDataError?.videocipher_resolution} defaultOptionName={"Choose an one resolution"} />
                                                                </>}

                                                            {(formData?.videocipher_resolution || siteTheme.enable_ppv_based_resolution == 1) ?
                                                                <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                                                                    <div className="dropZoneText d-flex align-items-center justify-content-center">
                                                                        <MessageBox text="Drag and drop video files here, or click to select files" classname="theme-text-color" />
                                                                    </div>
                                                                    <MessageSubHeading className={"text-center mt-4"} text={`Max Upload Limit (${storageSetting?.site_storage_limit} ${storageSetting?.site_storage_memory})`} />
                                                                    <input type="file" id="videoCipherUploadFile" data-test-id="videoCipherUploadFile" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" className="w-100 h-100" multiple onChange={(e) => { handleLibraryChange(e, "videocipher") }} />
                                                                </div> : ""}
                                                        </> : ""}
                                                </>
                                                : ""}
                                        </>
                                        : ""}

                                    {currentType == "m3u8_url" && (
                                        <>
                                            <MessageLabel text="M3u8 Url" />
                                            <AdminCustomInput id="video-m3u8-url" data-test-id="video-m3u8-url" type="text" name="m3u8_url" value={formData?.m3u8_url} onChange={handleInput} placeHolder={"Paste the m3u8 url"} ref={(el) => (combinedRef.current.m3u8_url = el)} error={formDataError?.m3u8_url} />
                                            {!currentId?.m3u8URLResponse?.id && <AdminCustomButton saveMethod={() => handleUrlUpload('m3u8_url')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                                            {currentId?.m3u8URLResponse?.id &&
                                                <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                                    <AdminCustomButton id="video-m3u8-url-add" saveMethod={() => handleAddMore('m3u8_url')} saveText="Add More" className="d-inline-block" />
                                                    <AdminCustomButton id="video-m3u8-url-next" saveMethod={() => handleNextMethod(currentId?.m3u8URLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                                                </div>}

                                        </>)
                                    }
                                    {currentType == "mp4_url" && (
                                        <>
                                            <MessageLabel text="Mp4 URL" />
                                            <AdminCustomInput id="video-mp4-url" data-test-id="video-mp4-url" type="text" name="mp4_url" value={formData?.mp4_url} onChange={handleInput} placeHolder={"Paste the mp4 url"} ref={(el) => (combinedRef.current.mp4_url = el)} error={formDataError?.mp4_url} />
                                            {!currentId?.mp4URLResponse?.id && <AdminCustomButton id="video-mp4-url-button" saveMethod={() => handleUrlUpload('mp4_url')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                                            {currentId?.mp4URLResponse?.id &&
                                                <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                                    <AdminCustomButton id="video-mp4-url-add" saveMethod={() => handleAddMore('mp4_url')} saveText="Add More" className="d-inline-block" />
                                                    <AdminCustomButton id="video-mp4-url-next" saveMethod={() => handleNextMethod(currentId?.mp4URLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                                                </div>}
                                        </>
                                    )}

                                    {currentType == "embed_code" && (
                                        <>
                                            <MessageLabel text="Embed code:" />
                                            <p className='mb-3'>( https://www.youtube.com/embed/xxxxx )</p>
                                            <AdminCustomInput id="video-embed-code" data-test-id="video-embed-code" type="text" name="embed_code" value={formData?.embed_code} onChange={handleInput} placeHolder={"Paste the embed code url"} ref={(el) => (combinedRef.current.embed_code = el)} error={formDataError?.embed_code} />
                                            {!currentId?.embedURLResponse?.id && <AdminCustomButton id="video-embed-code-button" saveMethod={() => handleUrlUpload('embed_code')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                                            {currentId?.embedURLResponse?.id &&
                                                <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                                    <AdminCustomButton id="video-mp4-url-add" saveMethod={() => handleAddMore('embed_code')} saveText="Add More" className="d-inline-block" />
                                                    <AdminCustomButton id="video-mp4-url-next" saveMethod={() => handleNextMethod(currentId?.embedURLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                                                </div>}
                                        </>
                                    )}

                                    {(currentType == "videocipher_url" && storageSetting?.videocipher_storage == 1) ?
                                        <>
                                            {siteTheme?.enable_ppv_based_resolution === 1 ? <>
                                                <p className=''>* Please select the correct resolution videos one by one based on the resolutions listed below</p>
                                                <div className='d-flex align-items-center my-3'>  {storageSetting?.videocipher_PPV_Resolution?.sort((a, b) => parseInt(a.label) - parseInt(b.label))?.map((item) => <span className={`custom-input-border  px-2 py-1 ${videoCipherIds?.some((entry) => entry?.resolution == item?.label) && "theme-button-bg-color theme-button-text-color"}`}>{item?.label}</span>)}</div>
                                            </>
                                                : <>
                                                    <p className=''>* Please select the one  resolution</p>
                                                    <AdminCustomSelect id="video-videocipher-resolution" data-test-id="video-videocipher-resolution" name="videocipher_resolution" className="d-block w-25 mt-3" value={formData?.videocipher_resolution || 0} onChange={handleInput} ref={(el) => (combinedRef.current.videocipher_resolution = el)} options={storageSetting?.transcoding_resolution} error={formDataError?.videocipher_resolution} defaultOptionName={"Choose an one resolution"} />
                                                </>}

                                            {siteTheme?.enable_ppv_based_resolution === 1}
                                            <div className='d-flex align-items-start flex-wrap' >
                                                {libraryVideos?.map((item) => {
                                                    return <div className="col-12 col-sm-6 col-md-4 col-xl-3 p-3 " key={item?.id}>
                                                        <div className="overflow-hidden position-relative">
                                                            <img src={item?.posters?.[0]?.posterUrl} className="w-100 table-column-grid-image overflow-hidden mb-2 rounded-3" />
                                                            <input
                                                                type="checkbox"
                                                                id="checkbox-library-item"
                                                                data-test-id={`checkbox-library-item-${item?.id}`}
                                                                checked={videoCipherIds?.some((entry => entry?.id == item?.id))}
                                                                onChange={() => handleRowSelect(item)}
                                                                className='table-checkbox-list position-absolute'
                                                            />
                                                            <span>{item?.title}</span>
                                                        </div>
                                                    </div>
                                                })}
                                            </div>
                                            <AdminCustomButton id="videoCipherOpenModel" saveMethod={openConfirmPOPUpVideoCipher} saveText="Move to Site Library" loading={showOverlay} className={"d-flex justify-content-end ms-auto mt-5"} />
                                        </>
                                        : ""}

                                    {currentType == "library" && <AdminCustomButton id="library-model" saveMethod={() => handleToggleGalleryModel(1)} saveText="Choose from library" className="mt-3" />
                                    }
                                    {currentType == "brightcove" && (
                                        <>
                                            <MessageLabel text="Brightcove Video ID" className="mandatorySimple" />
                                            <div className="w-100 align-items-center gap-3">
                                                <AdminCustomInput id="video-brightcove-id" data-test-id="video-brightcove-id" type="text" name="brightcove_video_id" value={formData?.brightcove_video_id} onChange={handleInput} placeHolder={"Enter Brightcove Video ID"} ref={(el) => (combinedRef.current.brightcove_video_id = el)} error={formDataError?.brightcove_video_id} />
                                                {/* Account ID input removed as per requirements */}
                                            </div>

                                            {currentId?.brightcoveResponse?.id ? (
                                                <div className="d-flex align-items-center justify-content-end mt-3">
                                                    <AdminCustomButton saveMethod={() => handleAddMore("brightcove")} saveText="Add More" />
                                                    <AdminCustomButton saveMethod={() => handleNextMethod(currentId?.brightcoveResponse?.id)} saveText="Proceed Next" className="ms-3" />
                                                </div>
                                            ) : (
                                                <AdminCustomButton saveMethod={() => handleUrlUpload('brightcove')} saveText="Submit" className="d-block mt-3 ms-auto" />
                                            )}
                                        </>
                                    )}
                                    {formData?.libraryMoveButton ? <Link className="col-2 d-block text-center  mx-auto admin-button-text mt-4 theme-button-bg-color theme-button-text-color rounded-2 px-3 py-2" to={`/edit-video/${formData?.libraryMoveButton}`} >Proceed Next</Link> : ""}


                                </div>
                            </>
                        </div>
                    </React.Fragment>}
                {step == 2 &&
                    <React.Fragment>
                        <AdminSaveHeader loading={loading} heading={!id ? labelDisplay?.[63]?.title : labelDisplay?.[0]?.title} saveText={!id ? labelDisplay?.[63]?.title : labelDisplay?.[1]?.title} saveMethod={handleStore} id={"video-preview-button"} link={id ? navigateChecker(languageCodeData, siteTheme, `videos/${formData.slug}`) : ""} />
                        <FormContainer className="pb-5">
                            <LeftWrapper>
                                <Wrapper>

                                    <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                                    <MessageSubHeading text={labelDisplay?.[2]?.sub_title} />
                                    <AdminCustomInput id="video-title" data-test-id="video-title" type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

                                    <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                                    <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                                    <AdminCustomInput id="video-slug" data-test-id="video-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onBlur={handleBlurTitleEdit} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />

                                    {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeModal} applySuggestion={confirmToggle} generateSuggestion={generateSuggestion} defaultPrompt={defaultPrompt} />)}
                                    <MessageLabel text={labelDisplay?.[4]?.title} enableAI handleAIModal={() => handleModal("description")} />
                                    <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
                                    <AdminCustomArea id="video-description" name="description" value={formData?.description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.description = el)} placeHolder={"description"} rows={5} maxLength={"250"} />

                                    <MessageLabel text={labelDisplay?.[5]?.title} enableAI handleAIModal={() => handleModal("details")} />
                                    <MessageSubHeading text={labelDisplay?.[5]?.sub_title} />
                                    <div data-test-id="video-details-editor">
                                        <JoditEditor className="video-details mb-3" ref={(el) => (combinedRef.current.details = el)} value={formData?.details} onChange={(newContent) => setFormData(prev => ({ ...prev, details: newContent }))} />
                                    </div>

                                    {/* Custom Fields */}

                                    <div className="card p-3 mt-3">

                                        {/* <MessageHeading text="Additional Fields" /> */}

                                        {/* Custom fields */}

                                        <FieldRenderer2
                                            pageIdentifier={editVideoStatus ? "videos.edit" : "videos.create"}
                                            entityType="video"
                                            entityId={id}
                                            text="Additional Fields"
                                        />
                                        <FieldRenderer
                                            pageIdentifier={editVideoStatus ? "videos.edit" : "videos.create"}
                                            entityType="video"
                                            entityId={id}
                                            onChange={setCustomFieldValues}
                                        />

                                    </div>


                                </Wrapper>

                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[8]?.title} />

                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="pe-2">
                                            <MessageLabel text={labelDisplay?.[12]?.title} className="mandatorySimple" />
                                            <MessageSubHeading text={labelDisplay?.[12]?.sub_title} />
                                        </div>
                                        <button type="button" id="video-category-add-button" className="vjs-big-play-button rounded" onClick={handleCategoryModalOpen} title="Add Category">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>
                                    {/* <select
                                        name="selected_categories"
                                        value={formData?.selected_categories || ""}
                                        onChange={handleMultiSelect}
                                        isMulti
                                        className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                                    >
                                        <option value="">Choose a category</option>
                                        {flatOptions.map(opt => (
                                            <option className="theme-bg-color theme-text-color" key={opt.id} value={opt.id}>{opt.label}</option>
                                        ))}
                                    </select> */}

                                    <CategoryMultiSelect
                                        options={defaultOption?.categoryOption}
                                        value={formData.selected_categories || []}
                                        onChange={(vals) =>
                                            setFormData(p => ({ ...p, selected_categories: vals }))
                                        }
                                        name={"selected_categories"}
                                    />

                                    {/* <Select id="video-category" data-test-id="video-category" options={defaultOption?.categoryOption} isMulti name={'selected_categories'} ref={(el) => (combinedRef.current.selected_categories = el)} onChange={handleMultiSelect} value={formData?.selected_categories} className={`${formDataError?.selected_categories && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} /> */}
                                    {formDataError?.selected_categories && (<MessageBox text={`${formDataError?.selected_categories}`} classname='errorred mb-2 d-block' />)}

                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="pe-2">
                                            <MessageLabel text={labelDisplay?.[10]?.title} className="mandatorySimple" />
                                            <MessageSubHeading text={labelDisplay?.[10]?.sub_title} />
                                        </div>
                                        <button type="button" id="video-age-add-button" className="vjs-big-play-button rounded" onClick={handleAgeModalOpen} title="Add Age">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>
                                    <AdminCustomSelect id="video-age-restrict" data-test-id="video-age-restrict" name="age_restrict" value={formData?.age_restrict} onChange={handleInput} ref={(el) => (combinedRef.current.age_restrict = el)} options={defaultOption?.ageOption?.map((item) => ({ name: item?.age, value: item?.age }))} error={formDataError?.age_restrict} defaultOptionName={"Choose an age"} />

                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="pe-2">
                                            <MessageLabel text="Content Classification" />
                                            <MessageSubHeading text="Select the content classification" />
                                        </div>
                                        <button type="button" id="video-classification-add-button" className="vjs-big-play-button rounded" onClick={handleClassificationModalOpen} title="Add Content Classification">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>

                                    <Select
                                        isMulti
                                        options={defaultOption?.classificationOption || []}
                                        value={selectedClassifications}
                                        onChange={handleClassificationChange}
                                        className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                        placeholder={defaultOption?.classificationOption?.length > 0 ? "Select Classifications" : "No classifications found"}
                                        noOptionsMessage={() => (
                                            <div className="p-2 text-center">
                                                <p className="mb-2">No classifications available.</p>
                                                <button type="button" className="btn btn-sm theme-button-bg-color text-white" onClick={handleClassificationModalOpen}>
                                                    Create Classification
                                                </button>
                                            </div>
                                        )}
                                    />

                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="pe-2">
                                            <MessageLabel text={labelDisplay?.[13]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[13]?.sub_title} />
                                        </div>
                                        <button type="button" id="video-language-add-button" className="vjs-big-play-button rounded" onClick={handleLanguageModalOpen} title="Add Language">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>
                                    <Select id="video-language" data-test-id="video-language" options={defaultOption?.languageOption} isMulti name={'selected_Languages'} onChange={handleMultiSelect} value={formData?.selected_Languages} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                                    {onlyPermission?.includes(47) && (
                                        <>
                                            <MessageLabel text={"Region"} />
                                            <MessageSubHeading text={"Add Region for the Video below"} />
                                            <Select id="video-region" options={defaultOption?.regionOption} isMulti name={'selected_Regions'} onChange={handleMultiSelect} value={formData?.selected_Regions} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                                        </>
                                    )}

                                    {/* cad3nce input fields */}

                                    {/* <MessageLabel text={"Director"} />
                                    <MessageSubHeading text={"Add Director for the Video below"} />
                                    <AdminCustomInput id="director" type="text" name="director" value={formData?.director} onChange={handleInput} placeHolder={"Director"} ref={(el) => (combinedRef.current.director = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.director} />

                                    <MessageLabel text={"Definition Quality"} />
                                    <MessageSubHeading text={"Add Definition Quality for the Video below"} />
                                    <AdminCustomInput id="definition_quality" type="text" name="definition_quality" value={formData?.definition_quality} onChange={handleInput} placeHolder={"Definition Quality"} ref={(el) => (combinedRef.current.definition_quality = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.definition_quality} />

                                    <MessageLabel text={"Original Production Company"} />
                                    <MessageSubHeading text={"Add Original Production Company for the Video below"} />
                                    <AdminCustomInput id="original_production_company" type="text" name="original_production_company" value={formData?.original_production_company} onChange={handleInput} placeHolder={"Original Production Company"} ref={(el) => (combinedRef.current.original_production_company = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.original_production_company} />

                                    <MessageLabel text={"Writers"} />
                                    <MessageSubHeading text={"Add Writers for the Video below"} />
                                    <AdminCustomInput id="writers" type="text" name="writers" value={formData?.writers} onChange={handleInput} placeHolder={"Writers"} ref={(el) => (combinedRef.current.writers = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.writers} />

                                    <MessageLabel text={"Info URL Footer Link"} />
                                    <MessageSubHeading text={"Add Info URL Footer Link for the Video below"} />
                                    <AdminCustomInput id="info_url_footer_link" type="text" name="info_url_footer_link" value={formData?.info_url_footer_link} onChange={handleInput} placeHolder={"Info URL Footer Link"} ref={(el) => (combinedRef.current.info_url_footer_link = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.info_url_footer_link} />

                                    <MessageLabel text={"Year"} />
                                    <MessageSubHeading text={"Add Year for the Video below"} />
                                    <AdminCustomInput id="year" type="text" name="year" value={formData?.year} onChange={handleInput} placeHolder={"Year"} ref={(el) => (combinedRef.current.year = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.year} />

                                    <MessageLabel text={"Country of Origin"} />
                                    <MessageSubHeading text={"Add Country of Origin for the Video below"} />
                                    <AdminCustomInput id="country_of_origin" type="text" name="country_of_origin" value={formData?.country_of_origin} onChange={handleInput} placeHolder={"Country of Origin"} ref={(el) => (combinedRef.current.country_of_origin = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.country_of_origin} /> */}

                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="pe-2">
                                            <MessageLabel text={labelDisplay?.[11]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[11]?.sub_title} />
                                        </div>
                                        <button type="button" id="video-artist-add-button" className="vjs-big-play-button rounded" onClick={handleArtistModalOpen} title="Add Artist">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>
                                    <Select id="video-artists" data-test-id="video-artists" options={defaultOption?.artistsOption} isMulti name={'selected_artists'} onChange={handleMultiSelect} value={formData?.selected_artists} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                                    <MessageLabel text={labelDisplay?.[9]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[9]?.sub_title} />
                                    <AdminCustomSelect id="video-rating" data-test-id="video-rating" name="rating" value={formData?.rating} onChange={handleInput} ref={(el) => (combinedRef.current.rating = el)} options={Array.from({ length: 10 })?.map((item, index) => ({ name: index + 1, value: index + 1 }))} error={formDataError?.rating} defaultOptionName={"Choose an rating"} />

                                    <MessageLabel text={labelDisplay?.[16]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[16]?.sub_title} />
                                    <Select id="video-related-videos" data-test-id="video-related-videos" options={defaultOption?.relatedVideos} isMulti name={`selected_related_videos`} onChange={handleMultiSelect} value={formData?.selected_related_videos} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                                    {/* <MessageLabel text={labelDisplay?.[17]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[17]?.sub_title} />
                                    <Select id="video-related-playlists" data-test-id="video-related-playlists" options={defaultOption?.relatedPlaylists} isMulti name={`selected_playlist_videos`} onChange={handleMultiSelect} value={formData?.selected_playlist_videos} className="custom-select-multi custom-placeholder theme-text-color mb-3" /> */}
                                </Wrapper>

                                {id && (
                                    <Wrapper>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <MessageHeading text="Video Playlist" noMargin />
                                            <Link id="video-manage-playlists" to="/allplaylist" target="_blank" rel="noopener noreferrer" title="Manage Playlists" className="admin-button-text theme-button-bg-color theme-button-text-color rounded-2 p-2 d-inline-flex align-items-center justify-content-center text-decoration-none">
                                                <FaExternalLinkAlt style={{ width: "16px", height: "16px" }} />
                                            </Link>
                                        </div>
                                        <MessageLabel text="Playlists" />
                                        <MessageSubHeading text="Select the playlists to assign to this video." />
                                        <Select
                                            id="video-playlist-multiselect"
                                            data-test-id="video-playlist-multiselect"
                                            isMulti
                                            options={videoPlaylistOptions}
                                            value={selectedVideoPlaylists}
                                            onChange={handleVideoPlaylistChange}
                                            isLoading={videoPlaylistLoading}
                                            isDisabled={videoPlaylistSyncing}
                                            placeholder={videoPlaylistOptions?.length > 0 ? "Select Playlists" : "No playlists found"}
                                            noOptionsMessage={() => (
                                                <div className="p-2 text-center">
                                                    <p className="mb-2">No playlists available.</p>
                                                    <Link to="/add-playlist" target="_blank" rel="noopener noreferrer" className="btn btn-sm theme-button-bg-color text-white text-decoration-none">
                                                        Create Playlist
                                                    </Link>
                                                </div>
                                            )}
                                            className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                        />
                                    </Wrapper>
                                )}

                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[41]?.title} />

                                    <MessageLabel text={labelDisplay?.[6]?.title} className="mandatorySimple" />
                                    <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />
                                    <AdminCustomInput id="video-duration" data-test-id="video-duration" type="text" maxLength="6" name="duration" value={formData?.duration} ref={(el) => (combinedRef.current.duration = el)} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.duration} />

                                    {currentType !== "embed_code" && (
                                        <>
                                            <div className="d-flex justify-content-between mb-2 mt-3">
                                                <div className="col-6 col-md-6 pe-2">
                                                    <MessageLabel text={labelDisplay?.[42]?.title} />
                                                </div>
                                                <div className="col-6 col-md-6 ps-2 text-end">
                                                    <AdminSwitch id="video-free-duration-status" name={'free_duration_status'} checked={formData?.free_duration_status} onChange={handleInput} />
                                                </div>
                                            </div>

                                            {formData?.free_duration_status == 1 && <>
                                                <MessageLabel text={labelDisplay?.[43]?.title} className={"mandatorySimple"} />
                                                <MessageSubHeading text={labelDisplay?.[43]?.sub_title} />
                                                <AdminCustomInput id={"video-free-duration-time"} data-test-id="video-free-duration-time" ref={(el) => (combinedRef.current.free_duration_time = el)} type="text" maxLength="6" name="free_duration_time" value={formData?.free_duration_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.free_duration_time} />
                                            </>}
                                        </>
                                    )}
                                </Wrapper>

                                {(getGeofencing === "ON" || getGeofencingAvailableCountries === 1) && (
                                    <Wrapper>
                                        <MessageHeading text={labelDisplay?.[69]?.title} />
                                        {getGeofencing === "ON" && (
                                            <>
                                                <MessageLabel text={labelDisplay?.[14]?.title} />
                                                <MessageSubHeading text={labelDisplay?.[14]?.sub_title} />
                                                <Select
                                                    id="video-block-country"
                                                    data-test-id="video-block-country"
                                                    options={defaultOption?.blockCountryOption?.filter(
                                                        (blockedItem) =>
                                                            !formData?.selected_available_country?.some(
                                                                (availableItem) => availableItem?.value === blockedItem?.value
                                                            )
                                                    )}
                                                    isMulti
                                                    name="selected_blocked_country"
                                                    onChange={handleMultiSelect}
                                                    value={formData?.selected_blocked_country}
                                                    className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                                />
                                            </>
                                        )}

                                        {getGeofencingAvailableCountries === 1 && (
                                            <>
                                                <MessageLabel text={labelDisplay?.[15]?.title} />
                                                <MessageSubHeading text={labelDisplay?.[15]?.sub_title} />
                                                <Select
                                                    id="video-available-country"
                                                    data-test-id="video-available-country"
                                                    options={defaultOption?.availableCountryOption?.filter(
                                                        (AvailableItem) =>
                                                            !formData?.selected_blocked_country?.some(
                                                                (blockedItem) => blockedItem?.value === AvailableItem?.value
                                                            )
                                                    )}
                                                    isMulti
                                                    name="selected_available_country"
                                                    onChange={handleMultiSelect}
                                                    value={formData?.selected_available_country}
                                                    className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                                />
                                            </>
                                        )}
                                    </Wrapper>
                                )}

                                <Wrapper>
                                    <h5 className={` theme-text-color  theme-border-secondary-color pb-3 mb-3 mt-0 `}>{labelDisplay?.[18]?.title} <small> {labelDisplay?.[18]?.sub_title} </small></h5>
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[19]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[19]?.sub_title} />
                                            <AdminCustomInput id="video-skip-start-time" data-test-id="video-skip-start-time" type="text" name="skip_start_time" value={formData?.skip_start_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.skip_start_time} maxLength={"6"} ref={(el) => (combinedRef.current.skip_start_time = el)} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2">
                                            <MessageLabel text={labelDisplay?.[20]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[20]?.sub_title} />
                                            <AdminCustomInput id="video-skip-end-time" data-test-id="video-skip-end-time" type="text" name="skip_end_time" value={formData?.skip_end_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.skip_end_time} maxLength={"6"} ref={(el) => (combinedRef.current.skip_end_time = el)} />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[21]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[21]?.sub_title} />
                                            <AdminCustomInput id="video-recap-start-time" data-test-id="video-recap-start-time" type="text" name="recap_start_time" value={formData?.recap_start_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.recap_start_time} maxLength={"6"} ref={(el) => (combinedRef.current.recap_start_time = el)} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2">
                                            <MessageLabel text={labelDisplay?.[22]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[22]?.sub_title} />
                                            <AdminCustomInput id="video-recap-end-time" data-test-id="video-recap-end-time" type="text" name="recap_end_time" value={formData?.recap_end_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.recap_end_time} maxLength={"6"} ref={(el) => (combinedRef.current.recap_end_time = el)} />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[23]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[23]?.sub_title} />
                                            <AdminCustomInput id="video-skip-start-session" data-test-id="video-skip-start-session" type="text" name="skip_start_session" value={formData?.skip_start_session} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.skip_start_session} maxLength={"6"} ref={(el) => (combinedRef.current.skip_start_session = el)} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2">
                                            <MessageLabel text={labelDisplay?.[24]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[24]?.sub_title} />
                                            <AdminCustomInput id="video-recap-start-session" data-test-id="video-recap-start-session" type="text" name="recap_start_session" value={formData?.recap_start_session} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.recap_start_session} maxLength={"6"} ref={(el) => (combinedRef.current.recap_start_session = el)} />
                                        </div>
                                    </div>
                                </Wrapper>

                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[25]?.title} />
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[26]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[26]?.sub_title} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminDownloadFile name={'Download'} value={formData?.pdf_files} link={formData?.url} />
                                        </div>
                                    </div>
                                    <AdminCustomInput id="video-epaper-upload" data-test-id="video-epaper-upload" className="form-control" type="file" name="pdf_files" previewFile={pdfFile?.name} onChange={handlePdfSubtitleFileChange} placeHolder={""} accept="application/pdf" error={formDataError?.pdf_files} />
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[27]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[27]?.sub_title} />
                                        </div>
                                        {/* <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminDownloadFile id="video-e-paper-download" name={'Download'} value={formData?.url_link} link={formData?.url_link} />
                                        </div> */}
                                    </div>
                                    <AdminCustomInput id="video-url-link" data-test-id="video-url-link" type="text" name="url_link" value={formData?.url_link} onChange={handleInput} placeHolder={"URL Link"} ref={(el) => (combinedRef.current.url_link = el)} error={formDataError?.url_link} />
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[28]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[28]?.sub_title} />
                                            <AdminCustomInput id="video-url-linktym" data-test-id="video-url-linktym" type="text" name="url_linktym" value={formData?.url_linktym} onChange={handleInput} placeHolder={"HHMMSS"} ref={(el) => (combinedRef.current.url_linktym = el)} error={formDataError?.url_linktym} maxLength={"8"} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2">
                                            <MessageLabel text={labelDisplay?.[29]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[29]?.sub_title} />
                                            <AdminCustomInput id="video-urlEnd-linksec" data-test-id="video-urlEnd-linksec" type="text" name="urlEnd_linksec" value={formData?.urlEnd_linksec} onChange={handleInput} placeHolder={"HHMMSS"} ref={(el) => (combinedRef.current.urlEnd_linksec = el)} error={formDataError?.urlEnd_linksec} maxLength={"8"} />
                                        </div>
                                    </div>
                                </Wrapper>
                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[36]?.title} />
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[37]?.title} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminSwitch id="video-featured" name={'featured'} checked={formData?.featured === 1} onChange={handleInput} />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[38]?.title} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminSwitch id="video-active" name={'active'} checked={formData?.active === 1} onChange={handleInput} />
                                        </div>
                                    </div>
                                    {(onlyPermission?.includes(48)) && (
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-6 col-md-6 pe-2">
                                                <MessageLabel text={"Promote as Advertisement"} />
                                            </div>
                                            <div className="col-6 col-md-6 ps-2 text-end">
                                                <AdminSwitch id="video-is-ads" name={'is_ads'} checked={formData?.is_ads === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[40]?.title} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminSwitch id="video-enable-video-title-image" name={'enable_video_title_image'} checked={formData?.enable_video_title_image} onChange={handleInput} />
                                        </div>
                                    </div>
                                    {(onlyPermission?.includes(45) || onlyPermission?.includes(46)) && (
                                        <>
                                            <div className="d-flex justify-content-between mb-2 ">
                                                <div className="col-6 col-md-6 pe-2">
                                                    <MessageLabel text={"Enable as Shorts"} />
                                                </div>
                                                <div className="col-6 col-md-6 ps-2 text-end">
                                                    <AdminSwitch id="video-is-shorts" name={'is_shorts'} checked={formData?.is_shorts === 1} onChange={handleInput} />
                                                </div>
                                            </div>
                                            {formData?.is_shorts === 1 && (
                                                <div className="d-flex align-items-center mb-2 ">
                                                    <div className="col-6 col-md-6 pe-2">
                                                        <MessageLabel text={"Shorts Type"} />
                                                    </div>
                                                    <div className="col-6 col-md-6 ps-2 d-flex justify-content-end align-items-center gap-2">
                                                        {onlyPermission?.includes(46) && (
                                                            <>
                                                                <AdminCustomRadio id="shorts-type-horizontal" name="shorts_type" value="horizontal" checked={formData?.shorts_type === 'horizontal'} onChange={handleInput} />
                                                                <MessageSubHeading text={"Horizontal"} noMargin />
                                                            </>
                                                        )}
                                                        {onlyPermission?.includes(45) && (
                                                            <>
                                                                <AdminCustomRadio id="shorts-type-vertical" name="shorts_type" value="vertical" checked={formData?.shorts_type === 'vertical'} onChange={handleInput} />
                                                                <MessageSubHeading text={"Vertical"} noMargin />
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Wrapper>
                                <Wrapper>
                                    <MessageHeading text="Slider Setting" />
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[39]?.title} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminSwitch id="video-banner" name={'banner'} checked={formData?.banner === 1} onChange={handleInput} />
                                        </div>
                                    </div>
                                    {formData?.banner === 1 && (
                                        <>
                                            <MessageLabel text="Slider Image" className={`${formData?.banner === 1 ? 'mandatorySimple' : ''}`} />
                                            <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                                            <AdminImageUploadZone
                                                idAttribute={`video-slider-image-${id}`}
                                                onChange={handleFileChange}
                                                selectedFile={sliderImageFile}
                                                uploadedImage={formData?.Slider_Thumbnail}
                                                onDelete={handleClearSelectFile}
                                                ref={(el) => (combinedRef.current.slider_image = el)}
                                                name="slider_image"
                                                apiFieldName="slider_image"
                                                error={formDataError?.slider_image}
                                                id={id}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                                <Wrapper>
                                    <MessageHeading text="Advertisement" />
                                    {siteTheme?.ssai_enable == 1 && (
                                        <Wrapper>
                                            <MessageLabel text="Ad Insertion Type" />
                                            <AdminCustomSelect name='ssai_enable' value={formData?.ssai_enable} onChange={handleInput} options={[{ name: 'CSAI (Client-Side Ad Insertion)', value: 0 }, { name: 'SSAI (Server-Side Ad Insertion)', value: 1 }]} defaultOptionName={'Choose Ad Type'} />
                                        </Wrapper>
                                    )}
                                    {siteTheme?.ssai_enable == 1 && formData?.ssai_enable == 1 ? (
                                        <FormContainer>
                                            <LeftWrapper>
                                                <MessageLabel text="SSAI Mid Ad Sequence Time" />
                                                <AdminCustomInput type="text" ref={(el) => (combinedRef.current.ssai_mid_ad_sequence_time = el)} name="ssai_mid_ad_sequence_time" value={formData?.ssai_mid_ad_sequence_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.ssai_mid_ad_sequence_time} maxLength={"6"} />
                                            </LeftWrapper>
                                        </FormContainer>
                                    ) : (
                                        <>
                                            <FormContainer>
                                                <LeftWrapper>
                                                    <MessageLabel text="Choose the Pre Position Advertisement" />
                                                    <AdminCustomSelect name='pre_ads' value={formData?.pre_ads} onChange={handleInput} options={defaultOption?.preAdvertisement?.map((item) => ({ name: item?.ads_name, value: item?.id }))} defaultOptionName={'Choose Pre Ads'} />
                                                </LeftWrapper>
                                                <RightWrapper>
                                                    <MessageLabel text="Choose the Post Position Advertisement" />
                                                    <AdminCustomSelect name='post_ads' value={formData?.post_ads} onChange={handleInput} options={defaultOption?.postAdvertisement?.map((item) => ({ name: item?.ads_name, value: item?.id }))} defaultOptionName={'Choose Post Ads'} />
                                                </RightWrapper>
                                            </FormContainer>
                                            <FormContainer>
                                                <LeftWrapper>
                                                    <MessageLabel text="Choose the Mid Category Advertisement" />
                                                    <AdminCustomSelect name='mid_ads_category' value={formData?.mid_ads_category} onChange={handleInput} options={defaultOption?.midAdsCategory?.map((item) => ({ name: item?.name, value: item?.id }))} defaultOptionName={'Choose Mid Ads Category'} />
                                                </LeftWrapper>
                                                <RightWrapper>
                                                    <MessageLabel text="Mid Advertisement Sequence Time" className={`${!formData?.mid_ads_category ? "" : "mandatorySimple"}`} />
                                                    <AdminCustomInput type="text" ref={(el) => (combinedRef.current.mid_advertisement_sequence_time = el)} name="mid_advertisement_sequence_time" value={formData?.mid_advertisement_sequence_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.mid_advertisement_sequence_time} maxLength={"6"} />
                                                </RightWrapper>
                                            </FormContainer>
                                        </>
                                    )}
                                </Wrapper>

                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper style={{ height: '85vh' }}>
                                    <MessageLabel text={`Active Video Type : ${formData?.type?.replace(/_/g, " ") == "transcoding video" || formData?.type?.replace(/_/g, " ") == "m3u8 url" ? "HLS" : formData?.type?.replace(/_/g, " ")}`} className={"mb-sm-3"} />
                                    {(formData?.video_url || formData?.mp4_url || formData?.m3u8_url) && formData?.video_format_type !== "embed_code" && !(formData?.type == "transcoding_video" && !formData?.m3u8_url) &&
                                        <AdminCustomURLCopy link={formData?.video_url || formData?.mp4_url || formData?.m3u8_url} fieldName={""} className="copy-board-input" />
                                    }

                                    <div className="adminVideoPlayer playerHeight vjs-16-9">
                                        {
                                            formData?.video_format_type == "embed_code" ? <AdminYoutubePlayer src={formData?.video_url} /> :
                                                (formData?.type == "transcoding_video" && !formData?.m3u8_url)
                                                    ? <AdminProcessButton cell={formData.draft == 0 ? "PROCESS" : formData.active == 1 && formData.status == 1 ? "PUBLISHED" : "UNPUBLISHED"} row={{ ...formData }} />
                                                    : <AdminMiniPlayer url={formData?.video_url || formData?.mp4_url || formData?.m3u8_url} videoFormat={formData?.video_format_type} title={formData?.title} poster={formData?.Player_thumbnail} className="playerHeight" />
                                        }
                                    </div>

                                </Wrapper>


                                <Wrapper >
                                    <MessageHeading text={labelDisplay?.[44]?.title} />
                                    <MessageLabel text={labelDisplay?.[45]?.title} className={`${imagerequiredValidation?.videos === 1 ? "mandatorySimple" : ""}`} />
                                    <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[45]?.sub_title, 'portrait')} />
                                    <AdminImageUploadZone
                                        idAttribute={`video-thumbnail-image-${id}`}
                                        onChange={handleFileChange}
                                        selectedFile={coverImageFile}
                                        uploadedImage={formData?.Thumbnail}
                                        onDelete={handleClearSelectFile}
                                        ref={(el) => (combinedRef.current.image = el)}
                                        name="image"
                                        apiFieldName="image"
                                        orientationSlug="portrait"
                                        enableCropping={siteTheme?.enable_image_cropping === 1}
                                        id={id}
                                        error={formDataError?.image}
                                    />
                                    <MessageLabel text={labelDisplay?.[46]?.title} className={`${imagerequiredValidation?.videos === 1 ? "mandatorySimple" : ""}`} />
                                    <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[46]?.sub_title, 'landscape')} />
                                    <AdminImageUploadZone
                                        idAttribute={`video-plyer-image-${id}`}
                                        onChange={handleFileChange}
                                        selectedFile={playerImageFile}
                                        uploadedImage={formData?.Player_thumbnail}
                                        onDelete={handleClearSelectFile}
                                        ref={(el) => (combinedRef.current.player = el)}
                                        name="player"
                                        apiFieldName="player_image"
                                        orientationSlug="landscape"
                                        enableCropping={siteTheme?.enable_image_cropping === 1}
                                        id={id}
                                        error={formDataError?.player}
                                    />
                                    <MessageLabel text={labelDisplay?.[47]?.title} className={`${imagerequiredValidation?.videos === 1 ? "mandatorySimple" : ""}`} />
                                    <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[47]?.sub_title, 'landscape')} />
                                    <AdminImageUploadZone
                                        idAttribute={`video-tv-image-${id}`}
                                        onChange={handleFileChange}
                                        selectedFile={tvImageFile}
                                        uploadedImage={formData?.TV_Thumbnail}
                                        onDelete={handleClearSelectFile}
                                        ref={(el) => (combinedRef.current.tv = el)}
                                        name="tv"
                                        apiFieldName="video_tv_image"
                                        orientationSlug="landscape"
                                        enableCropping={siteTheme?.enable_image_cropping === 1}
                                        error={formDataError?.tv}
                                        id={id}
                                    />
                                    <MessageLabel text={labelDisplay?.[48]?.title} />
                                    <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[48]?.sub_title, 'landscape')} />
                                    <AdminImageUploadZone
                                        idAttribute={`video-title-image-${id}`}
                                        onChange={handleFileChange}
                                        selectedFile={titleImageFile}
                                        uploadedImage={formData?.Video_Title_Thumbnail}
                                        onDelete={handleClearSelectFile}
                                        ref={(el) => (combinedRef.current.title_image = el)}
                                        name="title_image"
                                        apiFieldName="video_title_image"
                                        orientationSlug="landscape"
                                        enableCropping={siteTheme?.enable_image_cropping === 1}
                                        error={formDataError?.title_image}
                                        id={id}

                                    />
                                </Wrapper>

                                {/* <Wrapper>
                                    <MessageHeading text={labelDisplay?.[1]?.title} />
                                    <MessageLabel text={"Image"} />
                                    <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                                    <AdminImageUploadZone
                                        onChange={handleFileChange}
                                        selectedFile={reelsImageFile}
                                        uploadedImage={formData?.Video_reels_Thumbnail}
                                        onDelete={handleClearSelectFile}
                                        fileInputRef={focusInput}
                                        name="reels"
                                        id={id}

                                    />
                                </Wrapper> */}

                                <Wrapper style={formData?.trailer_format_type != null ? { height: '15%' } : {}}>
                                    <MessageHeading text={labelDisplay?.[52]?.title} />
                                    <MessageLabel text={labelDisplay?.[53]?.title} className="" />
                                    <MessageSubHeading text={labelDisplay?.[53]?.sub_title} />
                                    <AdminCustomSelect id="video-trailer-type" data-test-id="video-trailer-type" name="trailer_type" value={formData?.trailer_type} onChange={handleInput} ref={(el) => (combinedRef.current.trailer_type = el)} options={defaultOption?.trailerOption?.map((item) => ({ name: item?.name, value: item?.trailer_type }))} error={formDataError?.trailer_type} />
                                    {formData?.trailer_type == "mp4_video_upload" ? <> <input type="file" id="video-trailer" data-test-id="video-trailer" className="form-control" name="trailer" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" onChange={(e) => { handleLibraryChange(e, "trailer") }} />
                                        <AdminCustomButton id="libraryTrailer" saveMethod={() => handleToggleGalleryModel(16)} saveText="Choose from library" className="mt-2" />
                                    </> : ""}
                                    {formData?.trailer_type == "m3u8_url" ? <AdminCustomInput type="text" id="video-trailer-m3u8_url" data-test-id="video-trailer-m3u8_url" name="trailer_m3u8_url" ref={(el) => (combinedRef.current.trailer_m3u8_url = el)} value={formData?.trailer_m3u8_url} onChange={handleInput} placeHolder={"Please enter trailer m3u8 url"} error={formDataError?.trailer_m3u8_url} /> : ""}
                                    {formData?.trailer_type == "mp4_url" ? <AdminCustomInput type="text" id="video-trailer-mp4-url" data-test-id="video-trailer-mp4-url" name="trailer_mp4_url" ref={(el) => (combinedRef.current.trailer_mp4_url = el)} value={formData?.trailer_mp4_url} onChange={handleInput} placeHolder={"Please enter trailer mp4 url"} error={formDataError?.trailer_mp4_url} /> : ""}
                                    {formData?.trailer_type == "embed_code" ? <AdminCustomInput type="text" id="video-trailer-embed-code" data-test-id="video-trailer-embed-code" name="trailer_embed_code" ref={(el) => (combinedRef.current.trailer_embed_code = el)} value={formData?.trailer_embed_code} onChange={handleInput} placeHolder={"Please enter trailer embed code"} error={formDataError?.trailer_embed_code} /> : ""}
                                    {formData?.trailer_type == "brightcove" ? <AdminCustomInput type="text" id="video-trailer-brightcove" data-test-id="video-trailer-brightcove" name="brightcove_trailer_videos_id" ref={(el) => (combinedRef.current.brightcove_trailer_videos_id = el)} value={formData?.brightcove_trailer_videos_id} onChange={handleInput} placeHolder={"Please enter Brightcove Trailer Video ID"} error={formDataError?.brightcove_trailer_videos_id} /> : ""}

                                    {formData?.trailer_format_type != null ?
                                        <>
                                            <MessageLabel text={`Active Trailer Type : ${formData?.trailer_type?.replace(/_/g, " ") == "transcoding video" || formData?.trailer_type?.replace(/_/g, " ") == "m3u8 url" ? "HLS" : formData?.trailer_type?.replace(/_/g, " ")}`} className={"mb-sm-3"} />
                                            <div className="adminVideoPlayer playerHeight vjs-16-9">
                                                {
                                                    formData?.trailer_format_type == "embed_code" ? <AdminYoutubePlayer src={formData?.trailer_url} /> :
                                                        (formData?.trailer_type == "transcoding_video" && !formData?.trailer_m3u8_url)
                                                            ? <AdminProcessButton cell={!formData.trailer_m3u8_url ? "PROCESS" : "PUBLISHED"} row={{ ...formData }} />
                                                            : <AdminMiniPlayer url={formData?.trailer_url || formData?.trailer_mp4_url || formData?.trailer_m3u8_url} videoFormat={formData?.trailer_format_type} title={formData?.title ? `${formData.title} - Trailer` : ''} poster={formData?.Player_thumbnail} className="playerHeight" />
                                                }
                                            </div>
                                            {(formData?.trailer_url || formData?.trailer_mp4_url || formData?.trailer_m3u8_url) && formData?.trailer_format_type !== "embed_code" && !(formData?.trailer_type == "transcoding_video" && !formData?.trailer_m3u8_url) &&
                                                <AdminCustomURLCopy link={formData?.trailer_url || formData?.trailer_mp4_url || formData?.trailer_m3u8_url} fieldName={""} className="copy-board-input" />
                                            }
                                        </>
                                        : ""}

                                    {/* <MessageLabel text={"Trailer Description"} />
                                    <MessageSubHeading text={"Trailer Description"} />
                                    <AdminCustomArea id="trailer_description" name="trailer_description" value={formData?.trailer_description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.trailer_description = el)} placeHolder={"Please enter Trailer description"} rows={5} /> */}
                                </Wrapper>

                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[55]?.title} />
                                    <MessageLabel text={labelDisplay?.[56]?.title} />
                                    <div className='d-flex align-items-center justify-content-start gap-3'>
                                        <AdminCustomRadio id="video-publish-now" name="publish_now" checked={formData?.publish_type == "publish_now"} onChange={handleInput} />
                                        <MessageLabel text={labelDisplay?.[57]?.title} className="mb-md-0 mb-0" />
                                    </div>

                                    {formData?.publish_type == "publish_now" && (<>
                                        {/* <MessageLabel text={labelDisplay?.[7]?.title} /> */}
                                        {/* <MessageSubHeading text={labelDisplay?.[7]?.sub_title} /> */}
                                        <AdminCustomSelect id="video-year" data-test-id="video-year" name="year" value={formData?.year} onChange={handleInput} ref={(el) => (combinedRef.current.year = el)} options={years} error={formDataError?.year} defaultOptionName="Choose publish year" className={"mt-2"} />
                                    </>)}
                                    <div className='d-flex align-items-center justify-content-start gap-3'>
                                        <AdminCustomRadio id="video-publish-later" name="publish_later" checked={formData?.publish_type == "publish_later"} onChange={handleInput} />
                                        <MessageLabel text={labelDisplay?.[58]?.title} className="mb-md-0 mb-0" />
                                    </div>
                                    {formData?.publish_type == "publish_later" && (<>
                                        <MessageLabel text={labelDisplay?.[59]?.title} />
                                        <AdminCustomInput id="video-publish-time" data-test-id="video-publish-time" min={new Date().toISOString().slice(0, 16)} type="datetime-local" name="publish_time" value={formData?.publish_time} onChange={handleInput} placeHolder={"time "} ref={(el) => (combinedRef.current.publish_time = el)} error={formDataError?.publish_time} />
                                    </>)}
                                </Wrapper>

                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[60]?.title} />
                                    <MessageLabel text={labelDisplay?.[61]?.title} className="mandatorySimple" />
                                    <MessageSubHeading text={labelDisplay?.[60]?.sub_title} />
                                    <AdminCustomSelect id="video-access" data-test-id="video-access" name="access" value={formData?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={defaultOption?.accessOption?.map((item) => ({ name: item?.name, value: item?.role }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} />

                                    {formData?.access === "ppv" && <>
                                        {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                                            (
                                                <div className="mt-3">
                                                    <MessageLabel text={labelDisplay?.[64]?.title} />
                                                    <div className="d-flex justify-content-between mb-2 ">
                                                        <div className="col-6 col-md-6 pe-2">
                                                            <MessageSubHeading text={labelDisplay?.[64]?.sub_title} />
                                                        </div>
                                                        <div className="col-6 col-md-6 ps-2 text-end">
                                                            <AdminSwitch id="video-global-ppv" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                                                        </div>
                                                    </div>
                                                    <AdminCustomInput id="video-global-ppv-input" data-test-id="video-global-ppv-input" isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please eneter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />

                                                    <MessageLabel text={labelDisplay?.[65]?.title} />
                                                    {/* <div className="d-flex justify-content-between mb-2 ">
                                                        <div className="col-6 col-md-6 pe-2">
                                                        <MessageSubHeading text={labelDisplay?.[65]?.sub_title} />
                                                        </div>
                                                        <div className="col-6 col-md-6 ps-2 text-end">
                                                        <AdminSwitch name={'global_ios_ppv'} checked={formData?.global_ios_ppv == 1} onChange={handleInput} />
                                                        </div>
                                                    </div> */}
                                                    <AdminCustomSelect id="video-ios-ppv-price" data-test-id="video-ios-ppv-price" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />

                                                    {/* PPV Purchase Plans Field */}
                                                    <MessageLabel text="PPV Purchase Plan" />
                                                    <AdminCustomSelect
                                                        id="video-ppv-purchase-plans"
                                                        data-test-id="video-ppv-purchase-plans"
                                                        name="ppv_purchase_plans_id"
                                                        value={(() => {
                                                            if (!formData?.ppv_purchase_plans_id) return '';

                                                            try {
                                                                // Handle JSON string format: {"payment_id": 123}
                                                                if (typeof formData.ppv_purchase_plans_id === 'string') {
                                                                    // Check if it's a JSON string
                                                                    if (formData.ppv_purchase_plans_id.startsWith('{')) {
                                                                        const parsed = JSON.parse(formData.ppv_purchase_plans_id);
                                                                        return String(parsed.payment_id || '');
                                                                    }
                                                                    // Handle direct string ID
                                                                    return formData.ppv_purchase_plans_id;
                                                                }
                                                                // Handle direct number ID
                                                                return String(formData.ppv_purchase_plans_id);
                                                            } catch (error) {
                                                                console.log('Error parsing ppv_purchase_plans_id:', error, formData.ppv_purchase_plans_id);
                                                                return '';
                                                            }
                                                        })()}
                                                        onChange={(e) => handlePpvPlanSelect(e.target.value)}
                                                        options={defaultOption?.ppvPurchasePlans?.map((plan) => ({
                                                            name: plan?.plan_name || plan?.name || `Plan ${plan?.id}`,
                                                            value: plan?.id
                                                        })) || []}
                                                        defaultOptionName="Choose PPV plan"
                                                    />
                                                </div>
                                            )
                                            :
                                            <div className="mt-3">
                                                <AdminCustomButton id="video-custom-ppv-button" saveMethod={handleCustomizePPVClick} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                                            </div >
                                        }
                                    </>}
                                </Wrapper>

                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[30]?.title} />

                                    <MessageLabel text={labelDisplay?.[31]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[31]?.sub_title} />
                                    <AdminCustomInput id="video-website-page-title" data-test-id="video-website-page-title" name="website_page_title" value={formData?.website_page_title} ref={(el) => (combinedRef.current.website_page_title = el)} onChange={handleInput} placeHolder={"Website title"} error={formDataError?.website_page_title} />

                                    <MessageLabel text={labelDisplay?.[32]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[32]?.sub_title} />
                                    <AdminCustomInput id="video-website-url" data-test-id="video-website-url" name="website_URL" value={formData?.website_URL} onChange={handleInput} placeHolder={"Website url"} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.website_URL} />

                                    <MessageLabel text={labelDisplay?.[33]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[33]?.sub_title} />
                                    <AdminCustomArea id="video-meta-description" name="Meta_description" value={formData?.Meta_description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.Meta_description = el)} placeHolder={"Please enter Meta description"} rows={5} />
                                </Wrapper>
                                {onlyPermission?.includes(44) &&
                                    <PushNotificationSettings
                                        formData={formData}
                                        setFormData={setFormData}
                                        handleInput={handleInput}
                                        handleFileChange={handleFileChange}
                                        selectedFile={notificationImageFile}
                                        uploadedImage={formData?.push_notification_image}
                                        onDelete={handleClearSelectFile}
                                        combinedRef={combinedRef}
                                        formDataError={formDataError}
                                        siteTheme={siteTheme}
                                        id={id}
                                        onlyPermission={onlyPermission}
                                        sourceTitle={formData?.title}
                                        sourceDescription={formData?.description}
                                        sourceType={1}
                                        sourceTypeName="Videos"
                                        slug={formData?.slug}
                                        prefix="video"
                                    />
                                }



                                <Wrapper>
                                    <MessageHeading text={labelDisplay?.[34]?.title} />
                                    <MessageLabel text={labelDisplay?.[35]?.title} className="" />
                                    <MessageSubHeading text={labelDisplay?.[35]?.sub_title} />
                                    <TagsInput id="video-search-tags" data-test-id="video-search-tags" name="search_tags" value={formData?.search_tags} separators={["Enter", ","]} classNames={{ tag: "video-search-tags custom-search-tag", input: "w-100" }} onChange={handleTagsChange} />
                                </Wrapper>

                                <Wrapper>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <MessageHeading text={labelDisplay?.[62]?.title} noMargin />
                                        <div className="d-flex gap-2 pb-3">
                                            <AdminDownloadFile name="Sample SRT" value={true} link="/sample_subtitles/sample.srt" paddingClass="px-2 py-1" gapClass="gap-2" className="fs-7" />
                                            <AdminDownloadFile name="Sample VTT" value={true} link="/sample_subtitles/sample.vtt" paddingClass="px-2 py-1" gapClass="gap-2" className="fs-7" />
                                        </div>
                                    </div>

                                    {defaultOption?.videoSubtitle?.map((item, index) => (
                                        <div key={index}>
                                            <div className="d-flex justify-content-between mb-2 ">
                                                <div className="col-6 col-md-6 pe-2">
                                                    <MessageLabel text={item?.language} />
                                                </div>
                                                {item?.subtitle_url && <div className="col-6 col-md-6 ps-2 text-end mb-3 d-flex align-items-center justify-content-end gap-3">
                                                    {/* <AdminDownloadFile id="video-subtitle-url" name={'Download'} value={item?.subtitle_url} link={item?.subtitle_url} /> */}
                                                    <div onClick={() => handleSubtitleDelete(item)}>
                                                        <IconMyDelete styled={{ width: "20px", height: "20px" }} />
                                                    </div>
                                                </div>}
                                            </div>
                                            <AdminImageUploadZone
                                                idAttribute={`video-subtitle-${item?.short_code}-${id}`}
                                                onChange={handlePdfSubtitleFileChange}
                                                selectedFile={subtitleFile?.[item.short_code]}
                                                uploadedImage={item?.subtitle_url}
                                                onDelete={handleClearSelectFile}
                                                fileInputRef={focusInput}
                                                name={item?.short_code}
                                                id={id}
                                                previewFalse={true}
                                                accept="text/vtt,text/srt,.vtt,.srt"
                                                error={formDataError?.[item?.short_code]}
                                                icon={<PiSubtitlesLight />}
                                            />
                                        </div>
                                    ))}

                                </Wrapper>
                            </RightWrapper>
                            <AdminCustomButton id="videoFormSubmitButtonDown" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[63]?.title : labelDisplay?.[1]?.title} loading={loading} />
                        </FormContainer>
                    </React.Fragment>}
            </> : <MessageBox text={`${id} ${formData?.error}`} classname="px-3 py-5  d-block  totalText theme-bg-color rounded-3 shadow text-center w-50 mx-auto" />}
        </React.Fragment>
    );
}
const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
    storageLoading: state.storageSetting.loading,
    siteTheme: state.siteTheme.siteTheme,
    languageCodeData: state.languageCode.languageCodeData,
    onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(VideoAddUpdate)
